<style>
thead {
  background-color: #3d3d3d;
}

.v-data-table
  .v-table__wrapper
  > table
  > thead
  > tr
  > th.v-data-table__th--sortable:hover,
.v-data-table
  .v-table__wrapper
  > table
  tbody
  > tr
  > th.v-data-table__th--sortable:hover {
  cursor: unset;
  color: white;
}

.v-table > .v-table__wrapper > table > tbody > tr > th,
.v-table > .v-table__wrapper > table > thead > tr > th,
.v-table > .v-table__wrapper > table > tfoot > tr > th {
  font-weight: 500;
  user-select: none;
  text-align: start;
  color: white;
}

textarea {
  height: 80px;
}

.custom-date-input .v-field {
  min-height: 45px !important; /* igual que el text-field */
  height: 45px !important;
  align-items: center !important; /* centra verticalmente */
}

.custom-date-input .v-field__input {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
</style>

<template>
  <div
    style="
      padding: 20px;
      margin: 20px;
      background-color: white;
      border-radius: 10px;
    "
  >
    <h2 style="margin-bottom: 15px; font-weight: 600; border-bottom: 1px solid">
      Datos Generales
    </h2>
    <!-- Debug panel: añade ?debugTipos=true a la URL para mostrar los tipos recibidos y filtrados -->
    <div v-if="route.query.debugTipos === 'true'" style="background:#f6f6f6;border:1px dashed #ccc;padding:8px;margin-bottom:8px;">
      <strong>DEBUG: tipos desde API</strong>
      <pre style="white-space:pre-wrap;max-height:200px;overflow:auto">{{ JSON.stringify(lstTipoSolicitud, null, 2) }}</pre>
      <strong>DEBUG: tiposParaSeleccion</strong>
      <pre style="white-space:pre-wrap;max-height:200px;overflow:auto">{{ JSON.stringify(tiposParaSeleccion, null, 2) }}</pre>
    </div>
    <div class="d-flex flex-wrap ga-3">
      <div class="w-in">
        <label><b></b>Tipo Solicitud:</label>

        <v-autocomplete
          v-model="tipoSol"
          :items="tiposParaSeleccion"
          variant="solo"
          item-title="id"
          autocomplete="off"
          item-value="nombre"
          return-object
          @update:modelValue="cambioRetBodega"
        >
        </v-autocomplete>
      </div>

      <div class="w-in">
        <label>Fecha Solicitud:</label>

        <v-text-field
          pa-1
          hide-details
          ma-0
          v-model="date"
          type="date"
          variant="solo"
          color="primary"
          autocomplete="off"
          required
          disabled
        />
      </div>

      <!-- <div class="w-in" v-if="tipoSol?.id == 'Rendicion'">
        <label>Fecha Liberación:</label>

        <v-text-field
          pa-1
          hide-details
          ma-0
          v-model="fechaLiberacion"
          type="date"
          variant="solo"
          color="primary"
          autocomplete="off"
        />
      </div> -->

      <div class="w-in">
        <label>Ingresado Por:</label>

        <v-text-field
          variant="solo"
          pa-1
          ma-0
          v-model="solPorNombre"
          autocomplete="off"
          readonly
          hide-details
        >
        </v-text-field>
      </div>

      <div class="w-in">
        <label> Rut Ingresado Por: </label>
        <v-text-field
          variant="solo"
          pa-1
          ma-0
          v-model="solPorId"
          readonly
          autocomplete="off"
          hide-details
        >
        </v-text-field>
      </div>

      <div class="w-in">
        <label>Empresa:</label>

        <v-autocomplete
          v-model="empresaSel"
          :items="lstEmpresas"
          variant="solo"
          item-title="displayName"
          item-value="id"
          autocomplete="off"
          @update:modelValue="selectCompany"
          return-object
        >
        </v-autocomplete>
      </div>

      <div class="w-in">
        <label>Departamento:</label>

        <v-autocomplete
          v-model="departamentoSel"
          :items="lstDepartamento"
          variant="solo"
          item-title="codeDisplayName"
          item-value="id"
          clearable
          autocomplete="off"
          return-object
        >
        </v-autocomplete>
      </div>

      <div class="w-in" v-if="!isIngresoRespel(tipoSol?.id)">
        <label>Solicitante:</label>

        <v-autocomplete
          v-model="solicitanteSel"
          :items="lstSolicitantes"
          variant="solo"
          pa-1
          hide-details
          ma-0
          item-title="rutDisplayName"
          item-value="personId"
          clearable
          autocomplete="off"
          return-object
        >
        </v-autocomplete>
      </div>

      <div class="w-in" v-if="tipoSol?.id == 'Compra'">
        <label>Proveedor:</label>

        <v-autocomplete
          v-model="vendorSel"
          :items="lstVendors"
          variant="solo"
          item-title="numberDisplayName"
          item-value="id"
          clearable
          autocomplete="off"
          hide-details
          return-object
        >
        </v-autocomplete>
      </div>

      <div class="w-in" v-if="tipoSol?.id == 'Compra'">
        <label>Comprador:</label>

        <v-autocomplete
          v-model="compradorSel"
          :items="lstCompradores"
          variant="solo"
          item-title="name"
          item-value="code"
          clearable
          hide-details
          autocomplete="off"
          return-object
        >
        </v-autocomplete>
      </div>

      <div class="w-in" v-if="tipoSol?.id == 'Compra'">
        <label>¿La solicitud es regularización?</label>

        <v-autocomplete
          v-model="regSel"
          :items="lstRegularizacion"
          variant="solo"
          item-title="nombre"
          item-value="id"
          clearable
          hide-details
          autocomplete="off"
          return-object
          @update:modelValue="cambioRegJustificacion"
        >
        </v-autocomplete>
      </div>

      <div class="w-in" v-if="tipoSol?.id == 'Compra' && regSel?.id == 'Si'">
        <label>Justificación regularización</label>

        <v-autocomplete
          v-model="justSel"
          :items="lstJustificacion"
          variant="solo"
          item-title="nombre"
          item-value="id"
          clearable
          hide-details
          autocomplete="off"
          @update:modelValue="cambioJustificacion"
          return-object
        >
        </v-autocomplete>
      </div>

      <div
        class="w-in"
        v-if="tipoSol?.id == 'Compra' && regSel?.id == 'Si' && justSel?.id == 5"
      >
        <label>Autorizada Por:</label>

        <v-autocomplete
          v-model="autorizadorSel"
          :items="lstSolicitantes"
          variant="solo"
          pa-1
          hide-details
          ma-0
          item-title="rutDisplayName"
          item-value="personId"
          clearable
          autocomplete="off"
          return-object
        >
        </v-autocomplete>
      </div>

      <div
        class="w-in"
        v-if="tipoSol?.id == 'Compra' && regSel?.id == 'Si' && justSel?.id == 7"
      >
        <label>Descripción Otro:</label>

        <v-textarea
          variant="solo"
          pa-1
          ma-0
          v-model="descripOtro"
          hide-details
          autocomplete="off"
        >
        </v-textarea>
      </div>

      <div class="w-in" v-if="isRetiroTipo(tipoSol?.id)">
        <label>Cod. Bod:</label>

        <v-autocomplete
          variant="solo"
          :items="lstBodegas"
          hide-details
          pa-1
          ma-0
          clearable
          item-title="codeDisplayName"
          item-value="id"
          autocomplete="off"
          v-model="codigoBodega"
          return-object
        >
        </v-autocomplete>
      </div>

      <div class="w-in">
        <label>Observación:</label>

        <v-textarea
          variant="solo"
          pa-1
          ma-0
          v-model="obs"
          hide-details
          autocomplete="off"
        >
        </v-textarea>
      </div>

      <div class="w-in" v-if="isRetiroRespel(tipoSol?.id)">
        <label>N° Guía despacho:</label>

        <v-text-field
          variant="solo"
          pa-1
          ma-0
          v-model="codigoDespacho"
          hide-details
          autocomplete="off"
        >
        </v-text-field>
      </div>
    </div>
  </div>

  <div
    style="
      padding: 20px;
      margin: 20px;
      background-color: white;
      border-radius: 10px;
    "
  >
    <h2 style="font-weight: 600">Detalle Solicitud</h2>

    <div class="w-in">
      <label style="font-size: 16px">Busca Detalle:</label>

      <v-combobox
        style="font-size: 16px; margin-bottom: 10px"
        pa-1
        ref="mySearch"
        :loading="loading"
        :items="lstItems"
        :hide-no-data="false"
        v-model="item"
        item-title="numberDisplayName"
        item-value="id"
        variant="solo"
        dense
        hide-details
        autocomplete="off"
        clearable
        label="Busca un Material/Servicio"
        no-data-text="No se encontro Material/Servicio"
        @update:search="BuscarMaterial"
        return-object
      >
      </v-combobox>
    </div>

    <v-data-table
      v-if="tipoSol != null && tipoSol.id == 'Compra' && !isViveres"
      :headers="headers"
      :items="lstDetalle"
    >
      <template v-slot:item.cantidad="{ item }">
        <v-text-field
          variant="outlined"
          density="compact"
          hide-details
          autocomplete="off"
          pa-1
          ma-0
          v-model="item.cantidad"
          @keypress="filterNumber($event)"
          @update:modelValue="calcularTotalCantidad(item)"
        >
        </v-text-field>
      </template>

      <template v-slot:item.precio="{ item }">
        <v-text-field
          variant="outlined"
          density="compact"
          hide-details
          autocomplete="off"
          pa-1
          ma-0
          v-model="item.precio"
          @keypress="filterOnlyNumber($event)"
          @update:modelValue="calcularTotalCantidad(item)"
        >
        </v-text-field>
      </template>

      <template v-slot:item.total="{ item }">
        {{ formatTotal(item.total ?? 0) }}
      </template>

      <template v-slot:item.cecoId="{ item }">
        <v-autocomplete
          variant="outlined"
          :items="lstCeco"
          density="compact"
          pa-1
          ma-0
          hide-details
          autocomplete="off"
          item-title="codeDisplayName"
          item-value="id"
          :return-object="false"
          v-model="item.cecoId"
        >
        </v-autocomplete>
      </template>

      <template v-slot:item.proyectoId="{ item }">
        <v-autocomplete
          v-model="item.proyectoId"
          pa-1
          autocomplete="off"
          ma-0
          hide-details
          :items="lstProyectos"
          variant="outlined"
          density="compact"
          item-title="codeDisplayName"
          item-value="id"
          clearable
          :return-object="false"
        >
        </v-autocomplete>
      </template>

      <template v-slot:item.otMantencion="{ item }">
        <v-autocomplete
          v-model="item.otMantencion"
          pa-1
          autocomplete="off"
          ma-0
          hide-details
          :items="lstAuxNdoc"
          variant="outlined"
          density="compact"
          item-title="displayName"
          item-value="id"
          clearable
          :return-object="false"
        >
        </v-autocomplete>
      </template>

      <template v-slot:item.codigoBodega="{ item }">
        <v-autocomplete
          variant="outlined"
          :items="lstBodegas"
          density="compact"
          hide-details
          pa-1
          autocomplete="off"
          ma-0
          item-title="codeDisplayName"
          item-value="id"
          :return-object="false"
          v-model="item.codigoBodega"
        >
        </v-autocomplete>
      </template>

      <template v-slot:item.mesServicio="{ item }">
        <v-autocomplete
          variant="outlined"
          :items="lstMesServicio"
          density="compact"
          hide-details
          pa-1
          autocomplete="off"
          ma-0
          item-title="nombre"
          item-value="id"
          :return-object="false"
          v-model="item.mesServicio"
        >
        </v-autocomplete>
      </template>

      <template v-slot:item.fechaLimite="{ item }">
        <v-text-field
          pa-1
          ma-0
          v-model="item.fechaLimite"
          type="date"
          autocomplete="off"
          variant="outlined"
          color="primary"
          required
          density="compact"
          hide-details
          @click:control="openDatePicker"
          @focus="openDatePicker"
        />

        <!-- <v-date-input
          :model-value="toISO(item.fechaLimite)"
          @update:model-value="(val) => (item.fechaLimite = toDMY(val))"
          input-format="dd-MM-yyyy"
          display-format="dd-MM-yyyy"
          variant="solo"
          density="compact"
          hide-details
          color="primary"
          @click.stop
          @keydown.stop
        /> -->
      </template>

      <!-- <template v-slot:item.tienePresup="{ item }">
        <v-autocomplete
          variant="outlined"
          :items="lstTienePresup"
          density="compact"
          hide-details
          pa-1
          autocomplete="off"
          ma-0
          item-title="nombre"
          item-value="id"
          :return-object="false"
          v-model="item.tienePresup"
        >
        </v-autocomplete>
      </template> -->

      <!-- <template v-slot:item.concepto="{ item }">
        <v-autocomplete
          v-if="item.tienePresup"
          variant="outlined"
          :items="lstConceptos"
          density="compact"
          hide-details
          pa-1
          autocomplete="off"
          ma-0
          item-title="nombre_Concepto"
          item-value="codigo_Concepto"
          :return-object="false"
          v-model="item.concepto"
        >
        </v-autocomplete>

        <v-autocomplete
          v-else
          variant="outlined"
          density="compact"
          hide-details
          pa-1
          autocomplete="off"
          ma-0
          readonly
          item-title="nombre_Concepto"
          item-value="codigo_Concepto"
          :return-object="false"
          v-model="item.concepto"
        >
        </v-autocomplete>
      </template> -->

      <template v-slot:item.actions="{ item }">
        <v-icon icon="mdi-delete" color="red" @click="showDeleteDialog(item)" />
      </template>
    </v-data-table>

    <v-data-table
      v-if="tipoSol != null && tipoSol.id == 'Compra' && isViveres"
      :headers="headersTripulanteViveres"
      :items="lstDetalle"
    >
      <template v-slot:item.cantidad="{ item }">
        <v-text-field
          variant="outlined"
          density="compact"
          hide-details
          autocomplete="off"
          pa-1
          ma-0
          v-model="item.cantidad"
          @keypress="filterNumber($event)"
          @update:modelValue="calcularTotalCantidad(item)"
        >
        </v-text-field>
      </template>

      <template v-slot:item.precio="{ item }">
        <v-text-field
          variant="outlined"
          density="compact"
          hide-details
          autocomplete="off"
          pa-1
          ma-0
          v-model="item.precio"
          @keypress="filterOnlyNumber($event)"
          @update:modelValue="calcularTotalCantidad(item)"
        >
        </v-text-field>
      </template>

      <template v-slot:item.total="{ item }">
        {{ formatTotal(item.total ?? 0) }}
      </template>

      <template v-slot:item.cecoId="{ item }">
        <v-autocomplete
          variant="outlined"
          :items="lstCeco"
          density="compact"
          pa-1
          ma-0
          hide-details
          autocomplete="off"
          item-title="codeDisplayName"
          item-value="id"
          :return-object="false"
          v-model="item.cecoId"
        >
        </v-autocomplete>
      </template>

      <template v-slot:item.proyectoId="{ item }">
        <v-autocomplete
          v-model="item.proyectoId"
          pa-1
          autocomplete="off"
          ma-0
          hide-details
          :items="lstProyectos"
          variant="outlined"
          density="compact"
          item-title="codeDisplayName"
          item-value="id"
          clearable
          :return-object="false"
        >
        </v-autocomplete>
      </template>

      <template v-slot:item.otMantencion="{ item }">
        <v-autocomplete
          v-model="item.otMantencion"
          pa-1
          autocomplete="off"
          ma-0
          hide-details
          :items="lstAuxNdoc"
          variant="outlined"
          density="compact"
          item-title="displayName"
          item-value="id"
          clearable
          :return-object="false"
        >
        </v-autocomplete>
      </template>

      <template v-slot:item.codigoBodega="{ item }">
        <v-autocomplete
          variant="outlined"
          :items="lstBodegas"
          density="compact"
          hide-details
          pa-1
          autocomplete="off"
          ma-0
          item-title="codeDisplayName"
          item-value="id"
          :return-object="false"
          v-model="item.codigoBodega"
        >
        </v-autocomplete>
      </template>

      <template v-slot:item.mesServicio="{ item }">
        <v-autocomplete
          variant="outlined"
          :items="lstMesServicio"
          density="compact"
          hide-details
          pa-1
          autocomplete="off"
          ma-0
          item-title="nombre"
          item-value="id"
          :return-object="false"
          v-model="item.mesServicio"
        >
        </v-autocomplete>
      </template>

      <template v-slot:item.tripulanteId="{ item }">
        <v-autocomplete
          v-model="item.tripulanteId"
          pa-1
          autocomplete="off"
          ma-0
          hide-details
          :items="lstTripulantes"
          variant="outlined"
          density="compact"
          item-title="displayName"
          item-value="id"
          clearable
          :return-object="false"
        >
        </v-autocomplete>
      </template>

      <template v-slot:item.turnoId="{ item }">
        <v-autocomplete
          v-model="item.turnoId"
          pa-1
          autocomplete="off"
          ma-0
          hide-details
          :items="lstTurnos"
          variant="outlined"
          density="compact"
          item-title="displayName"
          item-value="id"
          clearable
          :return-object="false"
        >
        </v-autocomplete>
      </template>

      <template v-slot:item.fechaCompra="{ item }">
        <v-text-field
          pa-1
          ma-0
          v-model="item.fechaCompra"
          type="date"
          autocomplete="off"
          variant="outlined"
          color="primary"
          required
          density="compact"
          hide-details
          @click:control="openDatePicker"
          @focus="openDatePicker"
        />
      </template>

      <template v-slot:item.fechaTermino="{ item }">
        <v-text-field
          pa-1
          ma-0
          v-model="item.fechaTermino"
          type="date"
          autocomplete="off"
          variant="outlined"
          color="primary"
          required
          density="compact"
          hide-details
          @click:control="openDatePicker"
          @focus="openDatePicker"
        />
      </template>

      <template v-slot:item.fechaLimite="{ item }">
        <v-text-field
          pa-1
          ma-0
          v-model="item.fechaLimite"
          type="date"
          autocomplete="off"
          variant="outlined"
          color="primary"
          required
          density="compact"
          hide-details
          @click:control="openDatePicker"
          @focus="openDatePicker"
        />
        <!-- <v-date-input
          v-model="item.fechaLimite"
          input-format="dd-MM-yyyy"
          display-format="dd-MM-yyyy"
          variant="outlined"
          color="primary"
          autocomplete="off"
          required
          density="compact"
          hide-details
          class="custom-date-input"
        ></v-date-input> -->
      </template>

      <!-- <template v-slot:item.tienePresup="{ item }">
        <v-autocomplete
          variant="outlined"
          :items="lstTienePresup"
          density="compact"
          hide-details
          pa-1
          autocomplete="off"
          ma-0
          item-title="nombre"
          item-value="id"
          :return-object="false"
          v-model="item.tienePresup"
        >
        </v-autocomplete>
      </template> -->

      <!-- <template v-slot:item.concepto="{ item }">
        <v-autocomplete
          v-if="item.tienePresup"
          variant="outlined"
          :items="lstConceptos"
          density="compact"
          hide-details
          pa-1
          autocomplete="off"
          ma-0
          item-title="nombre_Concepto"
          item-value="codigo_Concepto"
          :return-object="false"
          v-model="item.concepto"
        >
        </v-autocomplete>

        <v-autocomplete
          v-else
          variant="outlined"
          density="compact"
          hide-details
          pa-1
          autocomplete="off"
          ma-0
          readonly
          item-title="nombre_Concepto"
          item-value="codigo_Concepto"
          :return-object="false"
          v-model="item.concepto"
        >
        </v-autocomplete>
      </template> -->

      <template v-slot:item.actions="{ item }">
        <v-icon icon="mdi-delete" color="red" @click="showDeleteDialog(item)" />
      </template>
    </v-data-table>

    <v-data-table
      v-if="tipoSol != null && tipoSol.id == 'Retiro Bodega'"
      :mobile-breakpoint="0"
      :headers="headersRetiro"
      :items="lstDetalle"
    >
      <template v-slot:item.tipo="{ item }">
        {{ item.tipo }}
      </template>

      <template v-slot:item.cantidad="{ item }">
        <v-text-field
          variant="outlined"
          density="compact"
          hide-details
          pa-1
          ma-0
          autocomplete="off"
          v-model="item.cantidad"
          @keypress="filterNumber($event)"
          @update:modelValue="formatoCantidad(item)"
        >
        </v-text-field>
      </template>

      <template v-slot:item.cecoId="{ item }">
        <v-autocomplete
          variant="outlined"
          :items="lstCeco"
          density="compact"
          pa-1
          autocomplete="off"
          ma-0
          hide-details
          item-title="codeDisplayName"
          item-value="id"
          :return-object="false"
          clearable
          v-model="item.cecoId"
        >
        </v-autocomplete>
      </template>

      <template v-slot:item.proyectoId="{ item }">
        <v-autocomplete
          v-model="item.proyectoId"
          pa-1
          ma-0
          hide-details
          autocomplete="off"
          :items="lstProyectos"
          variant="outlined"
          density="compact"
          item-title="codeDisplayName"
          item-value="id"
          clearable
          :return-object="false"
        >
        </v-autocomplete>
      </template>

      <template v-slot:item.otMantencion="{ item }">
        <v-autocomplete
          v-model="item.otMantencion"
          pa-1
          autocomplete="off"
          ma-0
          hide-details
          :items="lstAuxNdoc"
          variant="outlined"
          density="compact"
          item-title="displayName"
          item-value="id"
          clearable
          :return-object="false"
        >
        </v-autocomplete>
      </template>

      <template v-slot:item.numSerie="{ item }">
        <v-text-field
          variant="outlined"
          density="compact"
          hide-details
          pa-1
          ma-0
          autocomplete="off"
          v-model="item.numSerie"
        >
        </v-text-field>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-icon icon="mdi-delete" color="red" @click="showDeleteDialog(item)" />
      </template>
    </v-data-table>

    <v-data-table
      v-if="tipoSol?.id === 'Rendicion'"
      :headers="headersRendicion"
      :items="lstDetalle"
    >
      <template v-slot:item.tipoDoc="{ item }">
        <v-autocomplete
          variant="outlined"
          :items="lstTipoDoc"
          density="compact"
          pa-1
          ma-0
          hide-details
          item-title="nombre"
          autocomplete="off"
          item-value="id"
          :return-object="false"
          v-model="item.tipoDoc"
        >
        </v-autocomplete>
      </template>

      <template v-slot:item.nroDoc="{ item }">
        <div
          v-if="item.tipoDoc == 'Sin Documento' /* || item.TipoDoc == 'Vale' */"
        >
          <v-text-field
            pa-1
            ma-0
            v-model="item.nroDoc"
            variant="outlined"
            autocomplete="off"
            color="primary"
            required
            density="compact"
            hide-details
            readonly
          />
        </div>

        <div v-else>
          <v-text-field
            pa-1
            ma-0
            v-model="item.nroDoc"
            variant="outlined"
            color="primary"
            required
            autocomplete="off"
            density="compact"
            hide-details
          />
        </div>
      </template>

      <template v-slot:item.fechaDoc="{ item }">
        <v-text-field
          pa-1
          ma-0
          v-model="item.fechaDoc"
          type="date"
          autocomplete="off"
          variant="outlined"
          color="primary"
          required
          density="compact"
          hide-details
          @click:control="openDatePicker"
          @focus="openDatePicker"
        />
      </template>

      <template v-slot:item.proveedorId="{ item }">
        <v-autocomplete
          variant="outlined"
          :items="lstVendors"
          density="compact"
          autocomplete="off"
          pa-1
          ma-0
          hide-details
          item-title="numberDisplayName"
          item-value="id"
          :return-object="false"
          v-model="item.proveedorId"
          clearable
        >
        </v-autocomplete>
      </template>

      <template v-slot:item.descGasto="{ item }">
        <v-text-field
          pa-1
          ma-0
          v-model="item.descGasto"
          variant="outlined"
          autocomplete="off"
          color="primary"
          required
          density="compact"
          hide-details
        />
      </template>

      <template v-slot:item.monto="{ item }">
        <v-text-field
          variant="outlined"
          density="compact"
          hide-details
          pa-1
          ma-0
          autocomplete="off"
          v-model="item.monto"
          @keypress="filterOnlyNumber($event)"
          @update:modelValue="rendicionTotal(item)"
        >
        </v-text-field>
      </template>

      <template v-slot:item.cecoId="{ item }">
        <v-autocomplete
          variant="outlined"
          :items="lstCeco"
          density="compact"
          pa-1
          ma-0
          autocomplete="off"
          hide-details
          item-title="codeDisplayName"
          item-value="id"
          :return-object="false"
          v-model="item.cecoId"
          clearable
        >
        </v-autocomplete>
      </template>

      <template v-slot:item.proyectoId="{ item }">
        <v-autocomplete
          v-model="item.proyectoId"
          pa-1
          ma-0
          :items="lstProyectos"
          variant="outlined"
          item-title="codeDisplayName"
          item-value="id"
          density="compact"
          clearable
          autocomplete="off"
          :return-object="false"
          hide-details
        >
        </v-autocomplete>
      </template>

      <template v-slot:item.otMantencion="{ item }">
        <v-autocomplete
          v-model="item.otMantencion"
          pa-1
          autocomplete="off"
          ma-0
          hide-details
          :items="lstAuxNdoc"
          variant="outlined"
          density="compact"
          item-title="displayName"
          item-value="id"
          clearable
          :return-object="false"
        >
        </v-autocomplete>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-icon icon="mdi-delete" color="red" @click="showDeleteDialog(item)" />
      </template>
    </v-data-table>

    <v-data-table
      v-if="isRespelTipo(tipoSol?.id)"
      :headers="computedHeadersResiduo"
      :items="lstDetalle"
    >
      <template v-slot:item.cantidad="{ item }">
        <v-text-field
          variant="outlined"
          density="compact"
          hide-details
          autocomplete="off"
          pa-1
          ma-0
          v-model="item.cantidad"
        >
        </v-text-field>
      </template>

      <template v-slot:item.unidad="{ item }">
        <v-autocomplete
          variant="outlined"
          density="compact"
          hide-details
          autocomplete="off"
          pa-1
          ma-0
          :items="lstUnidadesResiduo"
          v-model="item.unidad"
          clearable
        >
        </v-autocomplete>
      </template>

      <template v-slot:item.cecoId="{ item }">
        <v-autocomplete
          variant="outlined"
          :items="lstCeco"
          density="compact"
          pa-1
          ma-0
          hide-details
          clearable
          autocomplete="off"
          item-title="codeDisplayName"
          item-value="id"
          :return-object="false"
          v-model="item.cecoId"
        >
        </v-autocomplete>
      </template>

      <template v-slot:item.codigoBodega="{ item }">
        <v-autocomplete
          variant="outlined"
          :items="lstBodegas"
          density="compact"
          hide-details
          pa-1
          autocomplete="off"
          ma-0
          item-title="codeDisplayName"
          item-value="id"
          clearable
          :return-object="false"
          v-model="item.codigoBodega"
        >
        </v-autocomplete>
      </template>

      <template v-slot:item.tipoResiduo="{ item }">
        <v-autocomplete
          variant="outlined"
          density="compact"
          hide-details
          autocomplete="off"
          pa-1
          ma-0
          :items="lstTiposResiduo"
          v-model="item.tipoResiduo"
          clearable
        >
        </v-autocomplete>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-icon icon="mdi-delete" color="red" @click="showDeleteDialog(item)" />
      </template>
    </v-data-table>

    <div
      v-if="tipoSol?.id == 'Compra' || tipoSol?.id == 'Rendicion'"
      style="
        font-size: 20px;
        font-weight: 600;
        margin-bottom: 5px;
        display: flex;
        justify-content: flex-end;
      "
    >
      Total: {{ formatTotal(total) }}
    </div>

    <div class="d-flex flex-wrap">
      <div class="w-in">
        <v-file-input
          pa-1
          ma-0
          hide-details
          v-model="selectedFiles"
          multiple
          label="Selecciona archivos"
          variant="solo"
          autocomplete="off"
          @update:modelValue="addFiles"
        >
        </v-file-input>

        <v-chip closable v-for="f in file" v-bind:key="f.name">
          {{ f.name }}
        </v-chip>
      </div>

      <div class="w-69 d-flex mt-3" style="justify-content: end">
        <v-btn
          style="
            background-color: #595959;
            padding: 15px;
            border-radius: 15px;
            color: white;
            margin-right: 5px;
            display: flex;
          "
          density="default"
          :loading="isLoading"
          :disabled="isLoading"
          v-on:click="guardarSolicitud()"
          >Guardar</v-btn
        >

        <v-btn
          style="
            background-color: #10510e;
            padding: 15px;
            border-radius: 15px;
            color: white;
            display: flex;
          "
          density="default"
          :loading="isLoading"
          :disabled="isLoading"
          v-on:click="crearSolicitud()"
          >Crear Solicitud</v-btn
        >
      </div>
    </div>
  </div>

  <v-dialog v-model="dialogDelete" persistent width="auto">
    <v-card>
      <v-card-title class="text-h5"> Borrar Item </v-card-title>
      <v-card-text>
        Esta seguro que desea item el material `{{
          itemToDelete.codigoMaterial
        }}` ?
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="dialogDelete = false">No</v-btn>
        <v-btn color="primary" @click="deleteMaterial(itemToDelete)">Si</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-overlay
    :model-value="isLoading"
    class="align-center justify-center"
    persistent
  >
    <v-progress-circular
      color="#a61a2f"
      size="50"
      :width="5"
      indeterminate
    ></v-progress-circular>
  </v-overlay>

  <v-overlay
    :model-value="isLoadingEmail"
    class="align-center justify-center"
    persistent
  >
    <div>
      <v-progress-circular
        color="#a61a2f"
        size="50"
        :width="5"
        indeterminate
      ></v-progress-circular>

      <div
        style="
          margin-top: 10px;
          margin-left: -50px;
          font-size: 15px;

          color: #000000;
        "
      >
        <b>Validando Identidad</b>
      </div>
    </div>
  </v-overlay>
</template>

<script setup lang="ts">
import type { Ref } from "vue";
import { reactive, ref, onMounted, watch } from "vue";
import { useStore } from "vuex";
import { key } from "@/store";
import axios from "axios";
import { useCookies } from "vue3-cookies";
import { useRouter, useRoute } from "vue-router";
import swal from "sweetalert2";
import { PublicClientApplication } from "@azure/msal-browser";
import AzureService from "../services/AzureService";
import currency from "currency.js";
import Emmitter from "tiny-emitter";
import { computed } from "vue";
import { translateBcError } from "@/utils/errorTranslator";
import { isIngresoRespel, isRetiroRespel, isRespelTipo, isRetiroTipo, TIPOS, normalizeTipoSolicitud } from "@/utils/tipoSolicitudHelpers";

import type { TipoSolicitud } from "../types/tipoSolicitud";
import type { Rol } from "../types/rol";
import type { Empleado } from "../types/empleado";
import type { Company } from "../types/company";
import type { Departamento } from "../types/departamento";
import type { Vendors } from "../types/vendors";
import type { Item } from "../types/item";
import type { SolicitudDetalle } from "../types/solicitudDetalle";
import type { Location } from "../types/location";
import type { TipoDocumento } from "../types/tipoDocumento";
import type { SolicitudEncabezado } from "../types/SolicitudEncabezado";
import type { SolicitudCompra } from "../types/solicitudCompra";
import type { Regularizacion } from "../types/regularizacion";
import type { Justificacion } from "../types/justificacion";
import type { Comprador } from "../types/comprador";
import type { MesServicio } from "../types/messervicio";
// import type { TienePresup } from "../types/tienePresup";
// import type { Presupuesto } from "../types/presupuesto";
// import type { Concepto } from "../types/concepto";

import useEmpresas from "../composables/useEmpresa";
import useDepartamentos from "../composables/useDepartamento";
import useComprador from "../composables/useComprador";
import useSolicitante from "../composables/useSolicitante";
import useBodegas from "../composables/useBodega";
import useCeco from "../composables/useCeco";
import useVendors from "../composables/useVendors";
import useAuxNdoc from "../composables/useAuxNdoc";
import useTripulante from "../composables/useTripulante";
import useTurno from "../composables/useTurno";
import useProyecto from "../composables/useProyecto";
// import useConcepto from "../composables/useConcepto";
// import usePresupuesto from "../composables/usePresupuesto";

const { cookies } = useCookies();
const store = useStore(key);
const router = useRouter();
const route = useRoute();

const idSol = computed(() => route.query.id as string | undefined);

let $msalInstance: PublicClientApplication;
const $emitter = new Emmitter.TinyEmitter();

const { getCompanies, lstEmpresas } = useEmpresas();
const { getDepartamentos, lstDepartamento } = useDepartamentos();
const { getSolicitantes, lstSolicitantes } = useSolicitante();
const { getVendors, lstVendors } = useVendors();
const { getCompradores, lstCompradores } = useComprador();
const { getBodegas, getBodegasResiduo, lstBodegas } = useBodegas();
const { getCeco, lstCeco } = useCeco();
const { getAuxNdoc, lstAuxNdoc } = useAuxNdoc();
const { getTripulantes, lstTripulantes } = useTripulante();
const { getTurnos, lstTurnos } = useTurno();
const { getProyectos, lstProyectos } = useProyecto();

// const { getConceptos, lstConceptos } = useConcepto();
// const { getPresupuesto, disminuirPresupuesto } = usePresupuesto();
// const { getPresupuesto, disminuirPresupuesto, presupuesto } = usePresupuesto();

let dialogDelete: Ref<boolean> = ref(false);
let itemToDelete: SolicitudDetalle = {};

let idSolicitud: string = "";
let isLoading = ref(false);
let total: Ref<number> = ref(0);

const lstTipoSolicitud = ref<TipoSolicitud[]>([
  { id: "Compra", nombre: "Compra" },
  { id: "Retiro Bodega", nombre: "Retiro Bodega" },
  { id: "Rendicion", nombre: "Rendicion" },
]);

const tiposParaSeleccion = computed(() => {
  const editing = idSol.value != undefined && idSol.value != null && idSol.value !== "";
  let items = lstTipoSolicitud.value.slice();
  // Excluir 'Todos' en el formulario de creación/edición
  items = items.filter((t) => t.id !== "Todos");
  // debug: mostrar lo que llega y qué se filtra
  if (editing) {
    return items;
  }
  if (esBodegaRespel.value) {
    return items;
  }
  const filtered = items.filter((t) => t.id !== "Retiro RESPEL");
  return filtered;
});

let date: string = new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
  .toISOString()
  .substr(0, 10);
let fechaLiberacion: string | null = null;

// let tipoSol: Ref<TipoSolicitud> = ref(lstTipoSolicitud[0]);
let tipoSol: Ref<TipoSolicitud | null> = ref(null);
let empresaSel: Ref<Company | null> = ref(null);
let departamentoSel: Ref<Departamento | null> = ref(null);
let solicitanteSel: Ref<Empleado | null> = ref(null);
let vendorSel: Ref<Vendors | null> = ref(null);
let compradorSel: Ref<Comprador | null> = ref(null);
let codigoBodega: Ref<Location | null> = ref(null);
let obs: Ref<string> = ref("");
let codigoDespacho: Ref<string> = ref("");
let lstItems: Ref<Item[]> = ref([]);
let item: Ref<Item | string | null> = ref(null);
let loading: boolean = false;
let detContador: number = 1;
let guid: string = "";
// let lstProyectos: Ref<Proyecto[]> = ref([]);
const lstDetalle = reactive<SolicitudDetalle[]>([]);
let selectedFiles: Ref<File[]> = ref([]);
let file: Ref<File[]> = ref([]);
let solPorId: Ref<string> = ref("");
let solPorNombre: Ref<string> = ref("");
let autorizador: Ref<string> = ref("");
let usuario: Ref<Empleado | null> = ref(null);
let regSel: Ref<Regularizacion | null> = ref(null);
let justSel: Ref<Justificacion | null> = ref(null);
let autorizadorSel: Ref<Empleado | null> = ref(null);
let descripOtro: Ref<string | null> = ref(null);
let isLoadingEmail: Ref<boolean> = ref(false);
let isUploadingFiles: Ref<boolean> = ref(false);
let isViveres: Ref<boolean> = ref(false);
let esBodegaRespel: Ref<boolean> = ref(false);
let esComprador: Ref<boolean> = ref(false);
// let mesServicioSel: Ref<MesServicio | null> = ref(null);

let headers: any = [
  { title: "Id", key: "id", width: "25px" },
  {
    title: "Cod",
    key: "codigoMaterial",
    align: "center",
    width: "100px!important",
  },
  {
    title: "Material/Servicio",
    key: "material",
    align: "center",
    width: "300px",
  },
  { title: "UN", key: "unidad", align: "center" },
  {
    title: "Fecha Límite",
    key: "fechaLimite",
    align: "center",
    width: "180px!important",
  },
  {
    title: "Cantidad",
    key: "cantidad",
    align: "center",
    width: "100px!important",
  },
  { title: "Precio", key: "precio", align: "center", width: "150px!important" },
  { title: "Total", key: "total", align: "center", width: "100px!important" },
  { title: "Ceco", key: "cecoId", align: "center", width: "200px!important" },
  {
    title: "Proyecto",
    key: "proyectoId",
    align: "center",
    width: "200px!important",
  },
  {
    title: "Bodega",
    key: "codigoBodega",
    align: "center",
    width: "200px!important",
  },
  {
    title: "OT Mantención | Partida Proyecto",
    key: "otMantencion",
    align: "center",
    width: "150px!important",
  },
  {
    title: "Mes servicio",
    key: "mesServicio",
    align: "center",
    width: "150px!important",
  },
  /*{
    title: "Tiene Presupuesto",
    key: "tienePresup",
    align: "center",
    width: "50px!important",
  },
  {
    title: "Concepto",
    key: "concepto",
    align: "center",
    width: "300px!important",
  },*/
  { title: "", key: "actions", align: "center", width: "25px" },
];

let headersTripulanteViveres: any = [
  { title: "Id", key: "id", width: "25px" },
  {
    title: "Cod",
    key: "codigoMaterial",
    align: "center",
    width: "100px!important",
  },
  {
    title: "Material/Servicio",
    key: "material",
    align: "center",
    width: "300px",
  },
  { title: "UN", key: "unidad", align: "center" },
  {
    title: "Fecha Límite",
    key: "fechaLimite",
    align: "center",
    width: "220px!important",
  },
  { title: "Precio", key: "precio", align: "center", width: "150px!important" },
  { title: "Total", key: "total", align: "center", width: "100px!important" },
  { title: "Ceco", key: "cecoId", align: "center", width: "200px!important" },
  {
    title: "Proyecto",
    key: "proyectoId",
    align: "center",
    width: "250px!important",
  },
  {
    title: "Tripulante",
    key: "tripulanteId",
    align: "center",
    width: "225px!important",
  },
  {
    title: "Turno",
    key: "turnoId",
    align: "center",
    width: "180px!important",
  },
  {
    title: "Fecha Compra",
    key: "fechaCompra",
    align: "center",
    width: "220px!important",
  },
  {
    title: "Fecha Término",
    key: "fechaTermino",
    align: "center",
    width: "220px!important",
  },
  {
    title: "Mes servicio",
    key: "mesServicio",
    align: "center",
    width: "150px!important",
  },
  /*{
    title: "Tiene Presupuesto",
    key: "tienePresup",
    align: "center",
    width: "50px!important",
  },
  {
    title: "Concepto",
    key: "concepto",
    align: "center",
    width: "300px!important",
  },*/
  { title: "", key: "actions", align: "center", width: "25px" },
];

let headersRetiro: any = [
  { title: "Id", key: "id", width: "25px" },
  { title: "Cod", key: "codigoMaterial", align: "center", width: "100px" },
  {
    title: "Material/Servicio",
    key: "material",
    align: "center",
    width: "300px",
  },
  {
    title: "Inventario",
    key: "inventario",
    align: "center",
    width: "50px",
  },
  { title: "N° Serie", key: "numSerie", align: "center", width: "150px" },
  { title: "UN", key: "unidad", align: "center", width: "25px" },
  {
    title: "Cantidad",
    key: "cantidad",
    align: "center",
    width: "120px!important",
  },
  { title: "Ceco", key: "cecoId", align: "center", width: "250px!important" },
  {
    title: "Proyecto",
    key: "proyectoId",
    align: "center",
    width: "200px!important",
  },
  {
    title: "OT Mantención | Partida Proyecto",
    key: "otMantencion",
    align: "center",
    width: "50px",
  },
  { title: "", key: "actions", align: "center", width: "25px" },
];

let headersRendicion: any = [
  { title: "Id", key: "id", width: "25px" },
  {
    title: "Tipo Docto",
    key: "tipoDoc",
    align: "center",
    width: "220px!important",
  },
  {
    title: "N° Docto",
    key: "nroDoc",
    align: "center",
    width: "100px!important",
  },
  {
    title: "Fecha Docto",
    key: "fechaDoc",
    align: "center",
    width: "200px!important",
  },
  {
    title: "Proveedor",
    key: "proveedorId",
    align: "center",
    width: "200px!important",
  },
  {
    title: "Material/Servicio",
    key: "material",
    align: "center",
    width: "150px",
  },
  {
    title: "Descripción del Gasto",
    key: "descGasto",
    align: "center",
    width: "150px",
  },
  { title: "Ceco", key: "cecoId", align: "center", width: "250px!important" },
  {
    title: "Proyecto",
    key: "proyectoId",
    align: "center",
    width: "200px!important",
  },
  { title: "Monto", key: "monto", align: "center", width: "150px!important" },
  {
    title: "OT Mantención",
    key: "otMantencion",
    align: "center",
    width: "50px",
  },
  { title: "", key: "actions", align: "center", width: "25px" },
];

let headersResiduo: any = [
  { title: "Id", key: "id", align: "center", width: "50px" },
  { title: "Cod", key: "codigoMaterial", align: "center", width: "150px" },
  {
    title: "Material/Servicio",
    key: "material",
    align: "center",
    width: "300px",
  },
  { title: "UN", key: "unidad", align: "center", width: "120px" },
  {
    title: "Cantidad",
    key: "cantidad",
    align: "center",
    width: "120px!important",
  },
  { title: "Ceco", key: "cecoId", align: "center", width: "200px!important" },
  {
    title: "Bodega",
    key: "codigoBodega",
    align: "center",
    width: "200px!important",
  },
  {
    title: "Tipo Residuo",
    key: "tipoResiduo",
    align: "center",
    width: "200px!important",
  },
  { title: "", key: "actions", align: "center", width: "25px" },
];

let lstTipoDoc: TipoDocumento[] = [
  { id: "Sin Documento", nombre: "Sin Documento" },
  { id: "Boleta", nombre: "Boleta" },
  { id: "Factura", nombre: "Factura" },
  { id: "Vale", nombre: "Vale" },
  { id: "B. Honorarios", nombre: "B. Honorarios" },
];

let lstRegularizacion: Regularizacion[] = [
  { id: "Si", nombre: "Si" },
  { id: "No", nombre: "No" },
];

const lstTiposResiduo: string[] = [
  "Industrial Peligroso",
  "Industrial No Peligroso",
  "Riles",
  "Domicilarios",
];

const lstUnidadesResiduo: string[] = ["lts", "tin", "un", "plt", "kg", "m3"];

let lstJustificacion: Justificacion[] = [
  { id: 1, nombre: "Adicionales" },
  { id: 2, nombre: "No planificado" },
  { id: 3, nombre: "Urgencia" },
  { id: 4, nombre: "Corrección tipo cambio" },
  { id: 5, nombre: "Regularización Autorizada por" },
  { id: 6, nombre: "Servicio recurrente, trabaja sin SOC" },
  { id: 7, nombre: "Otro justificar" },
];

let lstMesServicio: MesServicio[] = [];

/*let lstMesServicio: MesServicio[] = [
  { id: "2024-12", nombre: "2024-12" },
  { id: "2025-01", nombre: "2025-01" },
  { id: "2025-02", nombre: "2025-02" },
  { id: "2025-03", nombre: "2025-03" },
  { id: "2025-04", nombre: "2025-04" },
  { id: "2025-05", nombre: "2025-05" },
  { id: "2025-06", nombre: "2025-06" },
  { id: "2025-07", nombre: "2025-07" },
  { id: "2025-08", nombre: "2025-08" },
  { id: "2025-09", nombre: "2025-09" },
  { id: "2025-10", nombre: "2025-10" },
  { id: "2025-11", nombre: "2025-11" },
  { id: "2025-12", nombre: "2025-12" },
];*/

// let lstTienePresup: TienePresup[] = [
//   { id: true, nombre: "Si" },
//   { id: false, nombre: "No" },
// ];

// Filtrar headers para Retiro RESPEL (sin columna bodega ni tipo residuo)
const computedHeadersResiduo = computed(() => {
  const baseHeaders = [...headersResiduo];
  if (tipoSol.value?.id === 'Retiro RESPEL') {
    return baseHeaders.filter(h => h.key !== 'codigoBodega' && h.key !== 'tipoResiduo');
  }
  return baseHeaders;
});

onMounted(async () => {
  const azureService = new AzureService();
  $msalInstance = new PublicClientApplication(
    azureService.getMsalConfig().value,
  );

  await $msalInstance.initialize();
  await $msalInstance.handleRedirectPromise();
  $msalInstance.acquireTokenSilent({
    scopes: ["user.read", "mail.send"],
  });

  store.state.titulo = "Crear Solicitud";

  await getSolicitantes();

  if (cookies.get("username") != "") {
    await obtenerEmpleado(cookies.get("username"));
    // await obtenerEmpleado("imendoza@compasmarine.cl");

    await obtenerTiposSolicitud(solPorId.value || "");
    // determinar si el usuario tiene rol Aprobador RESPEL para filtrar en creación
    try {
      const roles = await getRol(cookies.get("username"));
      if (roles != null && roles.some((r: Rol) => r.rolNombre === "Aprobador RESPEL")) {
        esBodegaRespel.value = true;
      } else {
        esBodegaRespel.value = false;
      }
    } catch (e) {
      esBodegaRespel.value = false;
    }
    // Ajustar selección por defecto después de conocer roles: evitar 'Todos' y asegurarse de mostrar 'Ingreso RESPEL'
    try {


      if (idSol.value == undefined || idSol.value == null || idSol.value === "") {
        const opciones = tiposParaSeleccion.value;
        if (opciones && opciones.length > 0) {
          tipoSol.value = opciones[0];
        } else {
          const fallback = lstTipoSolicitud.value.find((t) => t.id !== "Todos" && t.id !== "Retiro RESPEL") || lstTipoSolicitud.value.find((t) => t.id !== "Todos") || lstTipoSolicitud.value[0] || { id: "Compra", nombre: "Compra" };
          tipoSol.value = fallback;
        }
      }
    } catch (e) {
      // no crítico
    }
  }

  guid = getGUID();

  if (idSol.value != undefined || idSol.value != null) {
    getSolicitudCompra();
  } else {
    // await getCompanies(solPorId.value || "", tipoSol.value?.id || "");
    await getCompanies(solPorId.value || "", null);

    if (lstEmpresas.value.length == 1) {
      const empresa = lstEmpresas.value[0];
      empresaSel.value = empresa;

      await getDepartamentos(empresa.id, solPorId.value);
      await getVendors(empresa.id);
      await getProyectos(empresa.id, solPorId.value);
      await getCeco(empresa.id);
      //await getBodegas(empresa.id);
      await getAuxNdoc(empresa.id);
      await getCompradores(empresa.id);

      if (isRespelTipo(tipoSol.value?.id)) {
        await getBodegasResiduo(empresa.id);
      } else {
        await getBodegas(empresa.id);
      }

      if (
        empresa.name == "18 - Trab. Marítimos Oxxean SA" ||
        empresa.name == "19 - TMO Acuicola S.A" ||
        empresa.name == "25 Consorcio De Proyectos Marí"
      ) {
        await getTripulantes(empresa.id);
        await getTurnos(empresa.id);
      }

      if (lstDepartamento.value.length == 1) {
        departamentoSel.value = lstDepartamento.value[0];
      }
    }

    const diciembreActual = new Date(new Date().getFullYear(), 11, 1); // mes 11 = diciembre
    lstMesServicio = generarMesesServicio(13, diciembreActual);
  }

  localStorage.removeItem("empresa");
  //await sendEmail("527ecef4-273e-4265-812b-46c86670d286");


});

const openDatePicker = (e: Event) => {
  // El evento viene del wrapper del text-field
  const root = e.currentTarget as HTMLElement | null;
  const input = root?.querySelector?.('input[type="date"]') as
    | HTMLInputElement
    | undefined;

  if (input?.showPicker) {
    input.showPicker(); // Chrome/Edge/Safari modernos
  } else {
    input?.focus(); // Fallback (p.ej. Firefox)
  }
};

async function BuscarMaterial() {
  if (empresaSel.value == null) {
    swal.fire({
      icon: "warning",
      title: "Debe seleccionar una empresa",
      showConfirmButton: true,
    });

    item.value = null;
    return;
  }

  if (tipoSol.value?.id == "Retiro Bodega" && codigoBodega.value == null) {
    swal.fire({
      icon: "warning",
      title: "Debe seleccionar una bodega",
      showConfirmButton: true,
    });

    item.value = null;
    return;
  }

  let det: SolicitudDetalle = {};

  if (typeof item.value === "string" || item.value instanceof String) {
    loading = true;

    let url: string =
      store.state.url +
      "api/Item/BuscadorItem?item=" +
      item.value +
      "&companyId=" +
      empresaSel.value.id;

    if (tipoSol.value?.id == "Retiro Bodega") {
      url =
        store.state.url +
        "api/Item/BuscadorItemRetiro?item=" +
        item.value +
        "&companyId=" +
        empresaSel.value.id +
        "&location=" +
        codigoBodega.value?.code;
    }

    if (isRespelTipo(tipoSol.value?.id)) {
      url =
        store.state.url +
        "api/Item/BuscadorItemResiduo?item=" +
        item.value +
        "&companyId=" +
        empresaSel.value.id;
    }

    if (item.value != null && new String(item.value).length > 2) {
      axios
        .get(url, {
          headers: {},
        })
        .then((response) => {
          if (response.status == 200) {
            lstItems.value = response.data;
            loading = false;
          } else {
            console.log(response.statusText);
          }
        })
        .catch(function (error: any) {
          console.log(error.message);
        });
      // .finally(() => (loading = false));
    }
  } else {
    if (item.value != null) {
      if (typeof item.value == "string" || item.value instanceof String) {
        return;
      }

      if (tipoSol.value?.id == "Rendicion") {
        det = {
          idItem: item.value.id,
          id: detContador,
          encabezadoId: guid,
          codigoMaterial: item.value.number,
          material: item.value.displayName,
          retiroBodega: false,
          monto: null,
          otMantencion: null,
          tipo: item.value.itemCategoryCode,
          generalProductPostingGroupCode:
            item.value.generalProductPostingGroupCode,
          cantidad: item.value.type == "Service" ? 1 : null,
        };
      } else {
        if (tipoSol.value?.id == "Retiro Bodega") {
          det = {
            idItem: item.value.id,
            id: detContador,
            tipo: item.value.itemCategoryCode,
            encabezadoId: guid,
            codigoMaterial: item.value.number,
            material: item.value.displayName,
            unidad: item.value.baseUnitOfMeasureCode,
            cantidad: item.value.type == "Service" ? 1 : null,
            precio: null,
            total: 0,
            retiroBodega: true,
            otMantencion: null,
            cantidadRetirar: 0,
            inventario: item.value.remainingQuantity || 0,
          };
        }

        if (tipoSol.value?.id == "Compra") {
          // console.log(item.value);
          // console.log(headersTripulante);

          det = {
            idItem: item.value.id,
            id: detContador,
            tipo: item.value.itemCategoryCode,
            encabezadoId: guid,
            codigoMaterial: item.value.number,
            material: item.value.displayName,
            unidad: item.value.baseUnitOfMeasureCode,
            cantidad: item.value.type == "Service" ? 1 : null,
            precio: null,
            total: 0,
            otMantencion: null,
          };

          if (
            item.value.number == "SER-410102" &&
            (empresaSel.value.name == "18 - Trab. Marítimos Oxxean SA" ||
              empresaSel.value.name == "19 - TMO Acuicola S.A" ||
              empresaSel.value.name == "25 Consorcio De Proyectos Marí")
          ) {
            isViveres.value = true;
            det.cantidad = 1;
          } else {
            isViveres.value = false;
            det.cantidad = item.value.type == "Service" ? 1 : null;
          }
        }

        if (isRespelTipo(tipoSol.value?.id)) {
          det = {
            idItem: item.value.id,
            id: detContador,
            tipo: item.value.itemCategoryCode,
            encabezadoId: guid,
            codigoMaterial: item.value.number,
            material: item.value.displayName,
            unidad: item.value.baseUnitOfMeasureCode,
            cantidad: null,
            tipoResiduo: null,
            cecoId: null,
            codigoBodega: null,
            cecoName: null,
            bodegaName: null,
          };
        }
      }

      if (det != null && lstDetalle != null) {
        if (
          tipoSol.value?.id == "Compra" &&
          (empresaSel.value.name == "18 - Trab. Marítimos Oxxean SA" ||
            empresaSel.value.name == "19 - TMO Acuicola S.A" ||
            empresaSel.value.name == "25 Consorcio De Proyectos Marí") &&
          lstDetalle.find((d) => d.codigoMaterial == "SER-410102") != null &&
          item.value.number != "SER-410102"
        ) {
          swal.fire({
            icon: "warning",
            title:
              "Si ya agrego el item de Viveres, no puede agregar otro diferente",
            showConfirmButton: true,
          });

          item.value = null;
          isViveres.value = true;
          return;
        }

        if (
          tipoSol.value?.id == "Compra" &&
          //lstDetalle.length > 0 &&
          lstDetalle.find((d) => d.codigoMaterial != "SER-410102") != null &&
          item.value.number == "SER-410102"
        ) {
          swal.fire({
            icon: "warning",
            title:
              "Si ya agrego otro item diferente a Viveres, no puede agregar Viveres",
            showConfirmButton: true,
          });

          item.value = null;
          isViveres.value = false;
          return;
        }

        lstDetalle.push(det);

        item.value = null;
        detContador++;
      }

      lstItems.value = [];
    }
  }
}

async function obtenerEmpleado(email: string) {
  try {
    isLoading.value = true;

    await axios
      .get(store.state.url + "api/Empleado/GetEmpleadoXEmail?email=" + email, {
        headers: {},
      })
      .then(async (response) => {
        if (response.status == 200) {
          usuario.value = response.data;
          autorizador.value = response.data.rut;

          solPorId.value = response.data.rut;
          solPorNombre.value = response.data.fullName;
        } else {
          console.log(response.statusText);
        }
      })
      .catch(function (error: any) {
        console.log(error.message);
      });
  } catch (error) {
    console.log(error);
  } finally {
    isLoading.value = false;
  }
}

// async function getProyectos() {
//   try {
//     if (empresaSel.value == null) {
//       return;
//     }

//     await axios
//       .get(
//         store.state.url +
//           "api/Proyecto/GetProyectos?company=" +
//           empresaSel.value.id,
//         { headers: {} }
//       )
//       .then((response) => {
//         if (response.status == 200) {
//           lstProyectos.value = response.data as Proyecto[];
//         } else {
//           console.log(response.statusText);
//         }
//       })
//       .catch(function (error) {
//         console.log(error.message);
//       });
//   } catch (error) {
//     console.log(error);
//   }
// }

function getSolicitudCompra() {
  try {
    axios
      .get(
        store.state.url +
          "api/SolicitudCompra/GetSolicitudCompra?solicitudId=" +
          idSol.value, //route.params.solicitudId
      )
      .then(async (response) => {
        if (response.status == 200) {
          let solicitud: SolicitudCompra = response.data;

          idSolicitud = solicitud.encabezado.id || "";

          const tipoSolicitudId = normalizeTipoSolicitud(solicitud.encabezado.tipoSolicitudId || "");
          tipoSol.value =
            lstTipoSolicitud.value.find((t) => t.id === tipoSolicitudId) ||
            (tipoSolicitudId
              ? { id: tipoSolicitudId, nombre: tipoSolicitudId }
              : null);

          date = solicitud.encabezado.fechaSolicitud || "";
          fechaLiberacion = solicitud.encabezado.fechaLiberacion ? solicitud.encabezado.fechaLiberacion.substr(0, 10) : null;

          await getCompanies(solPorId.value || "", null);

          if (solicitud.encabezado.companyId != null) {
            empresaSel.value =
              lstEmpresas.value.find(
                (r) => r.id == solicitud.encabezado.companyId,
              ) || null;
          }

          if (empresaSel.value != null) {
            await getDepartamentos(empresaSel.value.id, solPorId.value);
            await getCeco(empresaSel.value.id);
            //await getBodegas(empresaSel.value.id);
            await getVendors(empresaSel.value.id);
            await getProyectos(empresaSel.value.id, solPorId.value);
            await getAuxNdoc(empresaSel.value.id);
            await getCompradores(empresaSel.value?.id || "");

            if (isIngresoRespel(tipoSol.value?.id)) {
              await getBodegasResiduo(empresaSel.value.id);
            } else {
              await getBodegas(empresaSel.value.id);
            }

            if (
              empresaSel.value.name == "18 - Trab. Marítimos Oxxean SA" ||
              empresaSel.value.name == "19 - TMO Acuicola S.A" ||
              empresaSel.value.name == "25 Consorcio De Proyectos Marí"
            ) {
              await getTripulantes(empresaSel.value.id);
              await getTurnos(empresaSel.value.id);
            }
          }

          await getSolicitantes();

          // if (solicitud.encabezado.departamentoId != null) {
          departamentoSel.value =
            lstDepartamento.value.find(
              (d) => d.id == solicitud.encabezado.departamentoId,
            ) || null;
          // }

          solicitanteSel.value =
            lstSolicitantes.value.find(
              (s) => s.rut == solicitud.encabezado.solicitanteId,
            ) || null;

          obs.value = solicitud.encabezado.observacion || "";

          vendorSel.value =
            lstVendors.value.find(
              (v) => v.id == solicitud.encabezado.vendorId,
            ) || null;

          if (tipoSol.value?.id == "Retiro Bodega") {
            codigoBodega.value =
              lstBodegas.value.find(
                (b) => b.id == solicitud.encabezado.codigoBodega,
              ) || null;

            for (let i = 0; i < solicitud.detalle.length; i++) {
              solicitud.detalle[i].tipo = solicitud.detalle[i].tipo;
              solicitud.detalle[i].material = solicitud.detalle[i].material;
              solicitud.detalle[i].codigoMaterial =
                solicitud.detalle[i].codigoMaterial;

              solicitud.detalle[i].cantidad = solicitud.detalle[i].cantidad;
              solicitud.detalle[i].unidad = solicitud.detalle[i].unidad;
              // solicitud.detalle[i].inventario = solicitud.detalle[i].inventario;

              if (solicitud.detalle[i].cecoId != null) {
                solicitud.detalle[i].cecoId =
                  lstCeco.value.find((c) => c.id == solicitud.detalle[i].cecoId)
                    ?.id || null;
              }

              solicitud.detalle[i].proyectoId =
                lstProyectos.value.find(
                  (p) => p.id == solicitud.detalle[i].proyectoId,
                )?.id || null;

              solicitud.detalle[i].retiroBodega =
                solicitud.detalle[i].retiroBodega;

              solicitud.detalle[i].otMantencion =
                solicitud.detalle[i].otMantencion;

              // lstDetalle.push(solicitud.detalle[i]);
            }
          }

          if (tipoSol.value?.id == "Rendicion") {
            for (let i = 0; i < solicitud.detalle.length; i++) {
              solicitud.detalle[i].tipoDoc = lstTipoDoc.find(
                (t) => t.id == solicitud.detalle[i].tipoDoc,
              )?.id;

              solicitud.detalle[i].nroDoc = solicitud.detalle[i].nroDoc;

              if (solicitud.detalle[i].fechaDoc != null) {
                solicitud.detalle[i].fechaDoc = solicitud.detalle[i].fechaDoc;
              }

              if (solicitud.detalle[i].proveedorId != null) {
                solicitud.detalle[i].proveedorId = lstVendors.value.find(
                  (v) => v.id == solicitud.detalle[i].proveedorId,
                )?.id;
              }

              solicitud.detalle[i].material = solicitud.detalle[i].material;
              solicitud.detalle[i].descGasto = solicitud.detalle[i].descGasto;

              if (solicitud.detalle[i].cecoId != null) {
                solicitud.detalle[i].cecoId = lstCeco.value.find(
                  (c) => c.id == solicitud.detalle[i].cecoId,
                )?.id;
              }

              if (solicitud.detalle[i].proyectoId != null) {
                solicitud.detalle[i].proyectoId = lstProyectos.value.find(
                  (p) => p.id == solicitud.detalle[i].proyectoId,
                )?.id;
              }

              solicitud.detalle[i].monto = solicitud.detalle[i].monto;

              lstDetalle.push(solicitud.detalle[i]);
              rendicionTotal(solicitud.detalle[i]);
            }
          }

          if (tipoSol.value?.id == "Compra") {
            compradorSel.value =
              lstCompradores.value.find(
                (c) => c.code == solicitud.encabezado.comprador,
              ) || null;

            for (let i = 0; i < solicitud.detalle.length; i++) {
              solicitud.detalle[i].tipo = solicitud.detalle[i].tipo;
              solicitud.detalle[i].material = solicitud.detalle[i].material;
              solicitud.detalle[i].codigoMaterial =
                solicitud.detalle[i].codigoMaterial;

              solicitud.detalle[i].cantidad = solicitud.detalle[i].cantidad;
              solicitud.detalle[i].unidad = solicitud.detalle[i].unidad;

              if (solicitud.detalle[i].cecoId != null) {
                solicitud.detalle[i].cecoId = lstCeco.value.find(
                  (c) => c.id == solicitud.detalle[i].cecoId,
                )?.id;
              }

              solicitud.detalle[i].proyectoId = lstProyectos.value.find(
                (p) => p.id == solicitud.detalle[i].proyectoId,
              )?.id;

              solicitud.detalle[i].retiroBodega =
                solicitud.detalle[i].retiroBodega;
              solicitud.detalle[i].otMantencion =
                solicitud.detalle[i].otMantencion;

              if (solicitud.detalle[i].proveedorId != null) {
                solicitud.detalle[i].proveedorId = lstVendors.value.find(
                  (v) => v.id == solicitud.detalle[i].proveedorId,
                )?.id;
              }

              if (solicitud.detalle[i].codigoBodega != null) {
                solicitud.detalle[i].codigoBodega = lstBodegas.value.find(
                  (b) => b.id == solicitud.detalle[i].codigoBodega,
                )?.id;
              }

              solicitud.detalle[i].precio = solicitud.detalle[i].precio;
              solicitud.detalle[i].total = solicitud.detalle[i].total;

              if (solicitud.detalle[i].codigoMaterial == "SER-410102") {
                isViveres.value = true;

                if (solicitud.detalle[i].fechaCompra != null) {
                  solicitud.detalle[i].fechaCompra = solicitud.detalle[
                    i
                  ].fechaCompra?.substr(0, 10);
                }

                if (solicitud.detalle[i].fechaTermino != null) {
                  solicitud.detalle[i].fechaTermino = solicitud.detalle[
                    i
                  ].fechaTermino?.substr(0, 10);
                }
              } else {
                isViveres.value = false;
              }

              lstDetalle.push(solicitud.detalle[i]);

              //sumar total
              total.value = lstDetalle.reduce((acc, item) => acc + (item.total ?? 0), 0);
            }
          }

          //lstDetalle = solicitud.detalle;

          // for (let i = 0; i < solicitud.detalle.length; i++) {
          //   lstDetalle.push(solicitud.detalle[i]);
          // }

          detContador = lstDetalle.length + 1;
        }
      })
      .catch((e: any) => {
        console.log(e);
      })
      .finally(() => (isLoading.value = false));
  } catch (error) {
    console.log(error);
  }
}

async function crearSolicitud() {
  if (file.value.length > 0) {
    let totalSize = 0;
    file.value.forEach((f) => {
      totalSize += f.size;
    });

    if (totalSize > 200 * 1024 * 1024) {
      swal.fire({
        icon: "warning",
        title: "El tamaño de los archivos no puede superar los 200MB",
        showConfirmButton: true,
      });
      return;
    }
  }

  if (tipoSol == null) {
    swal.fire({
      icon: "warning",
      title: "Debe seleccionar un tipo de solicitud",
      showConfirmButton: true,
    });
    return;
  }

  if (
    solPorId.value == null ||
    solPorId.value == "" ||
    solPorNombre.value == null ||
    solPorNombre.value == ""
  ) {
    swal.fire({
      icon: "warning",
      title: "Debe haber un ingresado por",
      showConfirmButton: true,
    });
    return;
  }

  if (empresaSel.value == null) {
    swal.fire({
      icon: "warning",
      title: "Debe seleccionar una empresa",
      showConfirmButton: true,
    });
    return;
  }

  if (departamentoSel.value == null) {
    swal.fire({
      icon: "warning",
      title: "Debe seleccionar un departamento",
      showConfirmButton: true,
    });
    return;
  }

  if (!isRespelTipo(tipoSol.value?.id) && solicitanteSel.value == null) {
    swal.fire({
      icon: "warning",
      title: "Debe seleccionar un Solicitante",
      showConfirmButton: true,
    });
    return;
  }

  if (lstDetalle.length == 0) {
    swal.fire({
      icon: "warning",
      title: "Debe agregar al menos un material",
      showConfirmButton: true,
    });
    return;
  }

  if (lstDetalle.some((x) => x.cecoId == null)) {
    swal.fire({
      icon: "warning",
      title: "Debe seleccionar un ceco",
      showConfirmButton: true,
    });
    return;
  }

    if (!isRespelTipo(tipoSol.value?.id) && lstDetalle.some((x) => x.proyectoId == null)) {
      swal.fire({
        icon: "warning",
        title: "Debe seleccionar un proyecto",
        showConfirmButton: true,
      });
      return;
    }
  // }


  var encab: SolicitudEncabezado = {};
  var detalle: SolicitudDetalle[] | undefined = [];
  // var valPresupuesto: boolean = false;

  isLoading.value = true;
  try {
    if (tipoSol.value?.id == "Compra" || isRetiroTipo(tipoSol.value?.id) || isRespelTipo(tipoSol.value?.id)) {
      if (lstDetalle.some((x) => x.cantidad == 0 || x.cantidad == null)) {
        swal.fire({
          icon: "warning",
          title: "Debe ingresar una cantidad mayor a 0",
          showConfirmButton: true,
        });
        return;
      }

      encab = {
        id: guid,
        fechaSolicitud: date,
        solicitantePorId: solPorId.value,
        solicitantePorNombre: solPorNombre.value,
        companyId: empresaSel.value.id,
        departamentoId: departamentoSel.value.id,
        observacion: obs.value,
        ...(isRetiroRespel(tipoSol.value?.id) && { codigoDespacho: codigoDespacho.value }),
        solicitanteId: solicitanteSel.value?.rut,
        solicitanteNombre: solicitanteSel.value?.fullName,
        estado: "Creada",
        tipoSolicitudId: tipoSol.value?.id,
        // ProyectoId: proyectoSel != null ? proyectoSel.id : null,
      };

      detalle = lstDetalle;

      if (tipoSol.value?.id == "Compra") {

          var roles = await getRol(cookies.get("username"));
          if (roles != null && roles.some((r: Rol) => r.rolNombre === "Comprador")) {
            esComprador.value = true;
          } else {
            esComprador.value = false;
  }
        // if (mesServicioSel.value == null) {
        //   swal.fire({
        //     icon: "warning",
        //     title: "Debe seleccionar un mes de servicio",
        //     showConfirmButton: true,
        //   });
        //   return;
        // }

        if (vendorSel.value == null) {
          swal.fire({
            icon: "warning",
            title: "Debe seleccionar un proveedor",
            showConfirmButton: true,
          });
          return;
        }

        if (compradorSel.value == null) {
          swal.fire({
            icon: "warning",
            title: "Debe seleccionar un comprador",
            showConfirmButton: true,
          });
          return;
        }

        if (regSel.value?.id == null) {
          swal.fire({
            icon: "warning",
            title: "Debe seleccionar si es una regularización",
            showConfirmButton: true,
          });
          return;
        }

        if (regSel.value?.id == "Si" && justSel.value?.id == null) {
          swal.fire({
            icon: "warning",
            title: "Debe seleccionar una justificación",
            showConfirmButton: true,
          });
          return;
        }

        if (
          regSel.value?.id == "Si" &&
          justSel.value?.id == 5 &&
          autorizadorSel.value == null
        ) {
          swal.fire({
            icon: "warning",
            title: "Debe seleccionar un autorizador",
            showConfirmButton: true,
          });
          return;
        }

        if (
          regSel.value?.id == "Si" &&
          justSel.value?.id == 7 &&
          descripOtro.value == null
        ) {
          swal.fire({
            icon: "warning",
            title: "Debe ingresar una descripción",
            showConfirmButton: true,
          });
          return;
        }

        encab.vendorId = vendorSel.value != null ? vendorSel.value.number : null;
        encab.comprador = compradorSel.value.code;

        if (regSel.value.id == "Si") {
          encab.solRegularizacion = true;
        } else {
          if (regSel.value.id == "No") {
            encab.solRegularizacion = false;
          }
        }

        encab.justificacion = justSel.value?.nombre;
        encab.autorizadorJustificacion = autorizadorSel.value?.rut;
        encab.otraJustificacion = descripOtro.value;

        for (let i = 0; i < detalle.length; i++) {
          //validar que empresa sea la 18 - Trab. Marítimos Oxxean SA y que el ceco comience con 1 o 3
          // if (
          //   empresaSel.value.name == "18 - Trab. Marítimos Oxxean SA" &&
          //   detalle[i].codigoMaterial?.includes("CON-") &&
          //   detalle[i].codigoMaterial != "CON-000416" &&
          //   detalle[i].codigoMaterial != "CON-000417" && 
          //   detalle[i].codigoMaterial != "CON-000418" &&
          //   detalle[i].codigoMaterial != "CON-000415"
          // ) {
          //   let cecoSeleccionado = lstCeco.value.find(
          //     (c) => c.id == detalle?.[i]?.cecoId,
          //   )?.code;

          //   // if (
          //   //   regSel.value?.id == "No" &&
          //   //   !cecoSeleccionado?.code.startsWith("1") &&
          //   //   !cecoSeleccionado?.code.startsWith("3")
          //   // ) {
          //   //   swal.fire({
          //   //     icon: "warning",
          //   //     title:
          //   //       "ítems de tipo consumo deben solicitarse por la empresa 19 - TMO Acuicola S.A",
          //   //     showConfirmButton: true,
          //   //   });
          //   //   return;
          //   // }

          //   //validar que tenga seleccionada una bodega

          //   if (!validarCecoYEmpresa(cecoSeleccionado, regSel.value)) {
          //     return; // Cortas el flujo si no cumple
          //   }
          // }

          //verificar si la lista tiene algun elemento con codigo material que empieza con MAT- y si el usuario esComprador, si no es comprador arrojar mensaje
          if (
            detalle[i].codigoMaterial != null &&
            detalle[i].codigoMaterial?.includes("MAT-") &&
            !esComprador.value
          ) {
              swal.fire({
                icon: "warning",
                html:
                  '<span style="font-size:18px">Estimado(a),<br>Se informa que solo el área de Adquisiciones puede generar solicitudes de compra con código MAT.<br>Usted puede crear solicitudes de compra con todos los demás códigos habilitados.<br>Para más información, favor contactar a Adquisiciones.</span>',
                showConfirmButton: true,
              });
            return;
          }

          if (
            (empresaSel.value.name == "18 - Trab. Marítimos Oxxean SA" ||
              empresaSel.value.name == "19 - TMO Acuicola S.A" ||
              empresaSel.value.name == "25 Consorcio De Proyectos Marí") &&
            isViveres.value &&
            detalle[i].tripulanteId == null
          ) {
            swal.fire({
              icon: "warning",
              title:
                "Debe seleccionar un tripulante para el item " +
                detalle[i].material,
              showConfirmButton: true,
            });
            return;
          }

          if (
            (empresaSel.value.name == "18 - Trab. Marítimos Oxxean SA" ||
              empresaSel.value.name == "19 - TMO Acuicola S.A" ||
              empresaSel.value.name == "25 Consorcio De Proyectos Marí") &&
            isViveres.value &&
            detalle[i].turnoId == null
          ) {
            swal.fire({
              icon: "warning",
              title:
                "Debe seleccionar un turno para el item " + detalle[i].material,
              showConfirmButton: true,
            });
            return;
          }

          if (
            (empresaSel.value.name == "18 - Trab. Marítimos Oxxean SA" ||
              empresaSel.value.name == "19 - TMO Acuicola S.A" ||
              empresaSel.value.name == "25 Consorcio De Proyectos Marí") &&
            isViveres.value &&
            detalle[i].fechaCompra == null
          ) {
            swal.fire({
              icon: "warning",
              title:
                "Debe seleccionar una fecha de compra para el item " +
                detalle[i].material,
              showConfirmButton: true,
            });
            return;
          }

          if (
            (empresaSel.value.name == "18 - Trab. Marítimos Oxxean SA" ||
              empresaSel.value.name == "19 - TMO Acuicola S.A" ||
              empresaSel.value.name == "25 Consorcio De Proyectos Marí") &&
            isViveres.value &&
            detalle[i].fechaTermino == null
          ) {
            swal.fire({
              icon: "warning",
              title:
                "Debe seleccionar una fecha de término para el item " +
                detalle[i].material,
              showConfirmButton: true,
            });
            return;
          }

          if (
            detalle[i].codigoMaterial != null &&
            detalle[i].codigoMaterial?.includes("MAT-") &&
            detalle[i].codigoBodega == null &&
            !isViveres
          ) {
            swal.fire({
              icon: "warning",
              title:
                "Se debe seleccionar bodega para el item " +
                detalle[i].material,
              showConfirmButton: true,
            });
            return;
          }

          //validar que fecha compra sea una fecha valida con regex y el format "dd-MM-yyyy"
          if (
            (empresaSel.value.name == "18 - Trab. Marítimos Oxxean SA" ||
              empresaSel.value.name == "19 - TMO Acuicola S.A" ||
              empresaSel.value.name == "25 Consorcio De Proyectos Marí") &&
            isViveres.value &&
            detalle[i].fechaCompra != null
          ) {
            let regex = /^\d{4}-\d{2}-\d{2}$/;
            if (!regex.test(detalle[i].fechaCompra ?? "")) {
              swal.fire({
                icon: "warning",
                title: "La fecha de compra debe tener el formato dd-MM-yyyy",
                showConfirmButton: true,
              });
              return;
            }
          }

          //validar que fecha termino sea una fecha valida con regex y el format "dd-MM-yyyy"
          if (
            (empresaSel.value.name == "18 - Trab. Marítimos Oxxean SA" ||
              empresaSel.value.name == "19 - TMO Acuicola S.A" ||
              empresaSel.value.name == "25 Consorcio De Proyectos Marí") &&
            isViveres.value &&
            detalle[i].fechaTermino != null
          ) {
            let regex = /^\d{4}-\d{2}-\d{2}$/;
            if (!regex.test(detalle[i].fechaTermino ?? "")) {
              swal.fire({
                icon: "warning",
                title: "La fecha de término debe tener el formato dd-MM-yyyy",
                showConfirmButton: true,
              });
              return;
            }
          }

          if (
            (empresaSel.value.name == "18 - Trab. Marítimos Oxxean SA" ||
              empresaSel.value.name == "19 - TMO Acuicola S.A" ||
              empresaSel.value.name == "25 Consorcio De Proyectos Marí") &&
            isViveres.value &&
            detalle[i].fechaCompra != null &&
            detalle[i].fechaTermino != null
          ) {
            if (
              new Date(detalle[i].fechaCompra ?? "") >
              new Date(detalle[i].fechaTermino ?? "")
            ) {
              swal.fire({
                icon: "warning",
                title:
                  "La fecha de término debe ser mayor a la fecha de compra",
                showConfirmButton: true,
              });
              return;
            }
          }

          if (/*regSel.value?.id == "Si" &&*/ detalle[i].fechaLimite == null) {
            swal.fire({
              icon: "warning",
              title: "Debe seleccionar una fecha límite",
              showConfirmButton: true,
            });
            return;
          }

          if (
            /*regSel.value?.id == "Si" &&*/
            detalle[i].fechaLimite != null &&
            new Date(detalle[i].fechaLimite ?? "") <= new Date(date)
          ) {
            swal.fire({
              icon: "warning",
              title:
                "La fecha límite no puede ser menor a la fecha de solicitud",
              showConfirmButton: true,
            });
            return;
          }

          if (
            detalle[i].codigoMaterial?.startsWith("MAT-") &&
            detalle[i].codigoBodega == null
          ) {
            swal.fire({
              icon: "warning",
              title:
                "Se debe seleccionar bodega para el item " +
                detalle[i].material,
              showConfirmButton: true,
            });
            return;
          }

          // if (
          //   detalle[i].mesServicio == null &&
          //   detalle[i].codigoMaterial?.includes("SER-")
          // ) {
          //   swal.fire({
          //     icon: "warning",
          //     title:
          //       "Debe seleccionar un mes de servicio para el item " +
          //       detalle[i].material,
          //     showConfirmButton: true,
          //   });
          //   return;
          // }

          if (detalle[i].precio == null) {
            detalle[i].precio = 0;
          }

          detalle[i].deptoId = departamentoSel.value.id;

          if (idSol.value != undefined || idSol.value != null) {
            detalle[i].cecoId = detalle[i].cecoId;
            detalle[i].proyectoId = detalle[i].proyectoId;
            detalle[i].codigoBodega = detalle[i].codigoBodega;
          }
        }
      }

      if (isRetiroTipo(tipoSol.value?.id)) {
        encab.codigoBodega =
          codigoBodega.value != null ? codigoBodega.value.id : null;

        if (isRetiroRespel(tipoSol.value?.id)) {
          encab.codigoDespacho = codigoDespacho.value;
        }

        for (let i = 0; i < detalle.length; i++) {
          if (
            detalle[i].codigoMaterial == "MAT-001552" &&
            (detalle[i].numSerie == null ||
              detalle[i].numSerie == "" ||
              detalle[i].numSerie == undefined)
          ) {
            swal.fire({
              icon: "warning",
              title:
                "Se debe ingresar el número de serie para el item " +
                detalle[i].material,
              showConfirmButton: true,
            });
            return;
          }
          if (
            route.params.solicitudId != undefined ||
            route.params.solicitudId != null
          ) {
            // encab.codigoBodega =
            //   codigoBodega != null ? codigoBodega.value.id : null;

            if (detalle[i].cecoId != null) {
              detalle[i].cecoId = detalle[i].cecoId;
            }

            if (detalle[i].proyectoId != null) {
              detalle[i].proyectoId = detalle[i].proyectoId;
            }
          }

          detalle[i].deptoId = departamentoSel.value.id;
        }
      }

      if (isIngresoRespel(tipoSol.value?.id)) {
        // Validar que todos los items tengan tipo de residuo
        const sinTipoResiduo = detalle.find(d => d.tipoResiduo == null);
        if (sinTipoResiduo) {
          swal.fire({
            icon: "warning",
            title: "Debe seleccionar un tipo de residuo para el material " + sinTipoResiduo.material,
            showConfirmButton: true,
          });
          return;
        }

        detalle.forEach((d) => {
          d.deptoId = departamentoSel.value?.id;
        });
      }

      if (tipoSol.value?.id == "Retiro RESPEL" || tipoSol.value?.id == "Ingreso RESPEL") {
        detalle.forEach((d) => {
          d.deptoId = departamentoSel.value?.id;
        });
      }

      let solicitud: SolicitudCompra = {
        encabezado: encab,
        detalle: detalle,
      };

      if (idSol.value != undefined || idSol.value != null) {
        guid = getGUID();

        solicitud.encabezado.id = guid;

        for (let i = 0; i < solicitud.detalle.length; i++) {
          solicitud.detalle[i].encabezadoId = guid;
        }
      }

      /*if (tipoSol.value.id == "Compra") {
        validarPresupuesto(solicitud);
      } else {
        // console.log(JSON.stringify(solicitud));
        enviarSolicitud(solicitud);
      }*/

      // console.log(JSON.stringify(solicitud));
      enviarSolicitud(solicitud); 
    } else {
      if (tipoSol.value?.id == "Rendicion") {
        if (lstDetalle.some((x) => x.tipoDoc == null)) {
          swal.fire({
            icon: "warning",
            title: "Debe seleccionar un tipo de documento",
            showConfirmButton: true,
          });
          return;
        }

        if (lstDetalle.some((x) => x.fechaDoc == null)) {
          swal.fire({
            icon: "warning",
            title: "Debe seleccionar una fecha de documento",
            showConfirmButton: true,
          });
          return;
        }

        if (
          lstDetalle.some(
            (x) =>
              x.nroDoc == null &&
              x.tipoDoc != "Sin Documento" &&
              x.tipoDoc != "Vale",
          )
        ) {
          swal.fire({
            icon: "warning",
            title: "Debe ingresar un numero de documento",
            showConfirmButton: true,
          });
          return;
        }

        if (
          lstDetalle.some(
            (x) => x.proveedorId == null && x.tipoDoc == "Factura",
          )
        ) {
          swal.fire({
            icon: "warning",
            title: "Debe seleccionar un proveedor",
            showConfirmButton: true,
          });
          return;
        }

        if (
          lstDetalle.some(
            (x) => x.proveedorId == null && x.tipoDoc == "B. Honorarios",
          )
        ) {
          swal.fire({
            icon: "warning",
            title: "Debe seleccionar un proveedor",
            showConfirmButton: true,
          });
          return;
        }

        if (lstDetalle.some((x) => x.descGasto == null)) {
          swal.fire({
            icon: "warning",
            title: "Debe ingresar una descripción del gasto",
            showConfirmButton: true,
          });
          return;
        }

        if (lstDetalle.some((x) => x.monto == null || x.monto == 0)) {
          swal.fire({
            icon: "warning",
            title: "Debe ingresar un monto",
            showConfirmButton: true,
          });
          return;
        }

        encab = {
          id: guid,
          fechaSolicitud: date,
          solicitantePorId: solPorId.value,
          solicitantePorNombre: solPorNombre.value,
          companyId: empresaSel.value.id,
          departamentoId: departamentoSel.value.id,
          observacion: obs.value,
          solicitanteId: solicitanteSel.value?.rut ?? "",
          solicitanteNombre: solicitanteSel.value?.fullName ?? "",
          estado: "Creada",
          // fechaLiberacion: fechaLiberacion,
          tipoSolicitudId: tipoSol.value?.id,
        };

        detalle = lstDetalle;

        for (let i = 0; i < detalle.length; i++) {
          detalle[i].deptoId = departamentoSel.value.id;
        }

        let solicitud: SolicitudCompra = {
          encabezado: encab,
          detalle: detalle,
        };

        if (idSol.value != undefined || idSol.value != null) {
          guid = getGUID();

          solicitud.encabezado.id = guid;

          for (let i = 0; i < solicitud.detalle.length; i++) {
            solicitud.detalle[i].encabezadoId = guid;

            detalle[i].cecoId = detalle[i].cecoId;
            detalle[i].proyectoId = detalle[i].proyectoId;
            detalle[i].proveedorId = detalle[i].proveedorId;
            detalle[i].tipoDoc = detalle[i].tipoDoc;
          }
        }

        // console.log(JSON.stringify(solicitud));
        enviarSolicitud(solicitud);
      }
    }
  } catch (error) {
    console.log(error);
  } finally {
    isLoading.value = false;
  }
}

async function enviarSolicitud(solicitud: SolicitudCompra) {
  isLoading.value = true;

  axios
    .post(
      store.state.url + "api/SolicitudCompra/PostSolicitudCompra",
      solicitud,
    )
    .then(async (response) => {
      if (response.status == 200) {
        if (file.value.length > 0) {
          await submitFile(solicitud);
        }

        date = new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10);

        // swal.fire({
        //   icon: "success",
        //   title: "Solicitud creada exitosamente",
        //   showConfirmButton: false,
        //   timer: 2000,
        // });

        await sendEmail(solicitud.encabezado.id);

        // if (tipoSol.value.id == "Compra") {
        //   solicitud.detalle.forEach(async (det) => {
        //     if (
        //       det.cecoId != null &&
        //       det.concepto != null &&
        //       det.mesServicio != null &&
        //       det.total != null &&
        //       det.proyectoId != null
        //     ) {
        //       var depto = lstDepartamento.value.find(
        //         (d) => d.id == departamentoSel.value?.id
        //       );
        //       var ceco = lstCeco.value.find((c) => c.id == det.cecoId);
        //       var proyecto = lstProyectos.value.find(
        //         (p) => p.id == det.proyectoId
        //       );

        //       await disminuirPresupuesto(
        //         depto?.code ?? "",
        //         det.concepto,
        //         ceco?.code ?? "",
        //         proyecto?.displayName ?? "",
        //         det.total,
        //         det.mesServicio
        //       );
        //     }
        //   });
        // }

        swal.fire({
          icon: "success",
          title: "Solicitud creada exitosamente",
          showConfirmButton: false,
          timer: 2000,
        });

        guid = getGUID();

        router.push({
          name: "BuscaSolicitud",
        });
      } else {
        const t = translateBcError(response.data.error.message); // { message, correlationId, key }

        swal.fire({
          icon: "error",
          title: "Error al guardar la solicitud",
          text: t.message,
          showConfirmButton: true,
        });
      }
    })
    .catch((error: any) => {
      let errorMessage = "Error desconocido";
      
      if (error.response?.data?.message) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        errorMessage = error.message;
      }

      swal.fire({
        icon: "error",
        title: "Error al guardar la solicitud",
        text: errorMessage,
        showConfirmButton: true,
      });
    })
    .finally(() => (isLoading.value = false));
}

async function guardarSolicitud() {
  var encab: SolicitudEncabezado = {};
  var detalle: SolicitudDetalle[] = [];

  isLoading.value = true;
  try {
    if (
      solPorId.value == null ||
      solPorId.value == "" ||
      solPorNombre.value == null ||
      solPorNombre.value == ""
    ) {
      swal.fire({
        icon: "warning",
        title: "Debe haber un ingresado por",
        showConfirmButton: true,
      });
      return;
    }

    if (tipoSol.value?.id == "Compra" || isRetiroTipo(tipoSol.value?.id) || isRespelTipo(tipoSol.value?.id)) {
      encab = {
        id: guid,
        fechaSolicitud: date,
        solicitantePorId: solPorId.value,
        solicitantePorNombre: solPorNombre.value,
        companyId: empresaSel.value != null ? empresaSel.value?.id : null,
        departamentoId:
          departamentoSel.value != null ? departamentoSel.value.id : null,
        observacion: obs.value,
        solicitanteId:
          solicitanteSel.value != null ? solicitanteSel.value.rut : null,
        solicitanteNombre:
          solicitanteSel != null ? solicitanteSel.value?.fullName : null,
        estado: "Guardada",
        tipoSolicitudId: tipoSol.value?.id,
      };

      detalle = lstDetalle;

      // for (let i = 0; i < detalle.length; i++) {
      //   // var validCantidad = currency(detalle[i].cantidad, {
      //   //   decimal: ",",
      //   //   errorOnInvalid: true,
      //   // });
      //   // if (isNaN(validCantidad.value)) {
      //   //   swal.fire({
      //   //     icon: "warning",
      //   //     title: "La cantidad no es válida",
      //   //     showConfirmButton: true,
      //   //   });
      //   //   return;
      //   // }
      //   // detalle[i].cantidad = validCantidad.value;

      //   // detalle[i].cantidad = parseFloat(
      //   //   detalle[i]?.cantidad.toString().replace(",", ".")
      //   // );
      // }

      if (tipoSol.value?.id == "Compra") {
        encab.vendorId = vendorSel.value != null ? vendorSel.value.number : null;

        if (regSel.value?.id == "Si") {
          encab.solRegularizacion = true;
        } else {
          if (regSel.value?.id == "No") {
            encab.solRegularizacion = false;
          }
        }

        encab.justificacion = justSel.value?.nombre;
        encab.autorizadorJustificacion = autorizadorSel.value?.rut;
        encab.otraJustificacion = descripOtro.value;
        encab.comprador = compradorSel.value?.code;

        if (idSol.value != undefined || idSol.value != null) {
          for (let i = 0; i < detalle.length; i++) {
            detalle[i].cecoId = detalle[i].cecoId;
            detalle[i].proyectoId = detalle[i].proyectoId;
            detalle[i].codigoBodega = detalle[i].codigoBodega;
          }
        }
      }

      if (isRetiroTipo(tipoSol.value?.id)) {
        encab.codigoBodega =
          codigoBodega.value != null ? codigoBodega.value.id : null;

        if (isRetiroRespel(tipoSol.value?.id)) {
          encab.codigoDespacho = codigoDespacho.value;
        }

        if (idSol.value != undefined || idSol.value != null) {
          for (let i = 0; i < detalle.length; i++) {
            detalle[i].cecoId = detalle[i].cecoId;
            detalle[i].proyectoId = detalle[i].proyectoId;
          }
        }
      }

      let solicitud: SolicitudCompra = {
        encabezado: encab,
        detalle: detalle,
      };

      if (
        route.params.solicitudId != undefined ||
        route.params.solicitudId != null
      ) {
        guid = getGUID();

        solicitud.encabezado.id = guid;

        for (let i = 0; i < solicitud.detalle.length; i++) {
          solicitud.detalle[i].encabezadoId = guid;
        }
      }

      // console.log(JSON.stringify(solicitud));
      enviarSolicitudGuardada(solicitud);
    } else {
      if (tipoSol.value?.id == "Rendicion") {
        encab = {
          id: guid,
          fechaSolicitud: date,
          solicitantePorId: solPorId.value,
          solicitantePorNombre: solPorNombre.value,
          companyId: empresaSel.value != null ? empresaSel.value.id : null,
          departamentoId:
            departamentoSel.value != null ? departamentoSel.value.id : null,
          observacion: obs.value,
          solicitanteId:
            solicitanteSel.value != null ? solicitanteSel.value.rut : null,
          solicitanteNombre:
            solicitanteSel.value != null ? solicitanteSel.value.fullName : null,
          estado: "Guardada",
          // fechaLiberacion: fechaLiberacion,
          tipoSolicitudId: tipoSol.value?.id,
          // proyectoId: proyectoSel.value != null ? proyectoSel.id : null,
        };

        detalle = lstDetalle;

        if (departamentoSel.value != null) {
          for (let i = 0; i < detalle.length; i++) {
            detalle[i].deptoId = departamentoSel.value.id;

            if (
              route.params.solicitudId != undefined ||
              route.params.solicitudId != null
            ) {
              for (let i = 0; i < detalle.length; i++) {
                detalle[i].cecoId = detalle[i].cecoId;
                detalle[i].proyectoId = detalle[i].proyectoId;
                detalle[i].proveedorId = detalle[i].proveedorId;
                detalle[i].tipoDoc = detalle[i].tipoDoc;
              }
            }
          }
        }

        let solicitud: SolicitudCompra = {
          encabezado: encab,
          detalle: detalle,
        };

        if (idSol.value != undefined || idSol.value != null) {
          guid = getGUID();

          solicitud.encabezado.id = guid;

          for (let i = 0; i < solicitud.detalle.length; i++) {
            solicitud.detalle[i].encabezadoId = guid;
          }
        }

        // console.log(JSON.stringify(solicitud));
        enviarSolicitudGuardada(solicitud);
      }
    }
  } catch (error) {
    console.log(error);
  } finally {
    isLoading.value = false;
  }
}

async function enviarSolicitudGuardada(solicitud: SolicitudCompra) {
  isLoading.value = true;

  axios
    .post(
      store.state.url + "api/SolicitudCompra/PostSolicitudCompraGuardada",
      solicitud,
    )
    .then(async (response) => {
      if (response.status == 200) {
        if (file.value.length > 0) {
          await submitFile(solicitud);
        }

        date = new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10);

        total.value = 0;

        swal.fire({
          icon: "success",
          title: "Solicitud Guardada Exitosamente",
          showConfirmButton: false,
          timer: 2000,
        });

        guid = getGUID();

        router.push({
          name: "BuscaSolicitud",
        });
      } else {
        console.log("Error al guardar la solicitud: " + response.statusText);
        const t = translateBcError(response.data.error.message); // { message, correlationId, key }

        swal.fire({
          icon: "error",
          title: "Error al guardar la solicitud",
          text: t.message,
          showConfirmButton: true,
        });
        // console.log(response.statusText);
      }
    })
    .catch((error: any) => {
      console.log("Error al guardar la solicitud: " + error.message);
      
      let errorMessage = "Error desconocido";
      
      if (error.response?.data?.message) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        errorMessage = error.message;
      }

      swal.fire({
        icon: "error",
        title: "Error al guardar la solicitud",
        text: errorMessage,
        showConfirmButton: true,
      });
    })
    .finally(() => (isLoading.value = false));
}

async function sendEmail(idSol: string | undefined) {
  try {
    if (!idSol) {
      console.warn('[sendEmail] idSol undefined, skipping email.');
      return;
    }

    await axios
      .post(store.state.url + "api/SolicitudCompra/SendEmail?idSol=" + idSol)
      .then((response) => {
        if (response.status == 200) {
          const recipients: string[] = response.data?.recipients || [];
          const message: string = response.data?.message || "Resultado de envío sin mensaje.";
          console.log("[Email]", message, "Destinatarios:", recipients.join(", "));
        } else {
          console.log(response.statusText);
        }
      })
      .catch(function (error: any) {
        console.log(error);
      });
  } catch (error) {
    console.log(error);
  }
}

async function submitFile(solicitud: SolicitudCompra) {
  // Evitar ejecución múltiple
  if (isUploadingFiles.value) {
    console.log("Ya se están subiendo archivos, evitando duplicidad");
    return;
  }

  isUploadingFiles.value = true;

  try {
    const files = new FormData();

    for (let i = 0; i < file.value.length; i++) {
      files.append("files", file.value[i]);
    }

    // Si no hay archivos, no hacer la petición
    if (files.getAll("files").length === 0) {
      console.log("No hay archivos para subir");
      return;
    }

    const headers = { "Content-Type": "multipart/form-data" };

    await axios
      .post(
        store.state.url +
          "api/SolicitudCompra/UploadMultipleFile?solid=" +
          solicitud.encabezado.id +
          "&company=" +
          solicitud.encabezado.companyId,
        files,
        {
          headers,
        },
      )
      .then(async (res) => {
        if (res.status == 200) {
          await postFiles(res.data, solicitud.encabezado.id);
        } else {
          console.log("Error al cargar archivo, status code:" + res.status);
        }
      })
      .catch((error: any) => {
        console.error("Error al subir archivos:", error);
      });
  } finally {
    isLoading.value = false;
    isUploadingFiles.value = false;
  }
}

async function postFiles(files: File, solId: string | undefined) {
  await axios
    .post(
      store.state.url + "api/SolicitudCompra/PostFiles?solicitudId=" + solId,
      files,
      { headers: {} },
    )
    .then((response) => {
      if (response.status == 200) {
        console.log("Archivos subidos correctamente");
      } else {
        console.log(response.statusText);
      }
    })
    .catch(function (error: any) {
      console.log(error.message);
    });
}

async function cambioRetBodega() {
  if (tipoSol.value?.id == "Retiro Bodega") {
    for (var detRet of lstDetalle) {
      detRet.retiroBodega = true;
    }

    regSel.value = null;
    justSel.value = null;
    autorizadorSel.value = null;
    descripOtro.value = null;

    console.log('Cambio a Retiro Bodega, actualizando lista de empresas');
    await getCompanies(solPorId.value || "", tipoSol.value?.id || "");

    // Recargar bodegas según tipo y empresa seleccionada
    if (empresaSel.value != null) {
      await getBodegas(empresaSel.value.id);
      // limpiar selección de bodega si ya no está en la lista
      if (
        codigoBodega.value != null &&
        !lstBodegas.value.some((b) => b.id === (codigoBodega.value as any).id)
      ) {
        codigoBodega.value = null;
      }
    }
  } else if (isRespelTipo(tipoSol.value?.id)) {
    // Para tipos RESPEL, usar bodegas RESPEL
    regSel.value = null;
    justSel.value = null;
    autorizadorSel.value = null;
    descripOtro.value = null;

    console.log('Cambio a tipo RESPEL, actualizando lista de empresas');
    await getCompanies(solPorId.value || "", null);

    // Si hay empresa seleccionada, cargar solo bodegas RESPEL
    if (empresaSel.value != null) {
      await getBodegasResiduo(empresaSel.value.id);
      if (
        codigoBodega.value != null &&
        !lstBodegas.value.some((b) => b.id === (codigoBodega.value as any).id)
      ) {
        codigoBodega.value = null;
      }
    }
  } else {
    if (tipoSol.value?.id == "Rendicion") {
      regSel.value = null;
      justSel.value = null;
      autorizadorSel.value = null;
      descripOtro.value = null;
    }

    console.log('Cambio a otro tipo, actualizando lista de empresas');
    await getCompanies(solPorId.value || "", null);

    if (empresaSel.value != null) {
      await getBodegas(empresaSel.value.id);
      if (
        codigoBodega.value != null &&
        !lstBodegas.value.some((b) => b.id === (codigoBodega.value as any).id)
      ) {
        codigoBodega.value = null;
      }
    }

    for (var det of lstDetalle) {
      det.retiroBodega = false;
    }
  }
}

function cambioRegJustificacion() {
  if (regSel.value?.id == "No") {
    justSel.value = null;
    autorizadorSel.value = null;
    descripOtro.value = null;
  }
}

function cambioJustificacion() {
  if (justSel.value?.id == 5 || justSel.value?.id == 7) {
    if (justSel.value?.id == 5) {
      descripOtro.value = null;
    }

    if (justSel.value?.id == 7) {
      autorizadorSel.value = null;
    }
  } else {
    autorizadorSel.value = null;
    descripOtro.value = null;
  }
}

async function selectCompany() {
  console.log('Cambio de empresa a:', empresaSel.value?.displayName || empresaSel.value);
  try {
    if (localStorage.getItem("empresa") != null) {
      await swal
        .fire({
          icon: "warning",
          title: "Se perderán los datos ingresados, ¿Desea continuar?",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Si",
          cancelButtonText: "No",
          allowOutsideClick: false,
        })
        .then(async (result: any) => {
          if (result.isConfirmed) {
            isLoading.value = true;
            if (empresaSel.value != null) {
              localStorage.setItem("empresa", JSON.stringify(empresaSel.value));

              departamentoSel.value = null;
              vendorSel.value = null;
              solicitanteSel.value = null;
              codigoBodega.value = null;
              compradorSel.value = null;
              regSel.value = null;
              justSel.value = null;
              autorizadorSel.value = null;
              descripOtro.value = null;
              obs.value = "";

              lstDetalle.length = 0;

              await getDepartamentos(empresaSel.value.id, solPorId.value);
              await getVendors(empresaSel.value.id);
              await getProyectos(empresaSel.value.id, solPorId.value);
              await getCeco(empresaSel.value.id);
              //await getBodegas(empresaSel.value.id);
              await getAuxNdoc(empresaSel.value.id);
              await getCompradores(empresaSel.value?.id || "");

              if (isRespelTipo(tipoSol.value?.id)) {
                await getBodegasResiduo(empresaSel.value.id);
              } else {
                await getBodegas(empresaSel.value.id);
              }

              if (
                empresaSel.value.name == "18 - Trab. Marítimos Oxxean SA" ||
                empresaSel.value.name == "19 - TMO Acuicola S.A" ||
                empresaSel.value.name == "25 Consorcio De Proyectos Marí"
              ) {
                await getTripulantes(empresaSel.value.id);
                await getTurnos(empresaSel.value.id);
              }

              if (lstDepartamento.value.length == 1) {
                departamentoSel.value = lstDepartamento.value[0];
              }

              // if (tipoSol.value.id == "Compra") {
              //   await getConceptos();
              // }
            }
          } else {
            let jsonEmp = localStorage.getItem("empresa");
            if (jsonEmp != null) {
              empresaSel.value = JSON.parse(jsonEmp);
            }
          }
        });
    } else {
      isLoading.value = true;
      localStorage.setItem("empresa", JSON.stringify(empresaSel.value));

      if (empresaSel.value != null) {
        await getDepartamentos(empresaSel.value.id, solPorId.value);
        await getVendors(empresaSel.value.id);
        await getProyectos(empresaSel.value.id, solPorId.value);
        await getCeco(empresaSel.value.id);
        //await getBodegas(empresaSel.value.id);
        await getAuxNdoc(empresaSel.value.id);
        await getCompradores(empresaSel.value?.id || "");

        if (isRespelTipo(tipoSol.value?.id)) {
          await getBodegasResiduo(empresaSel.value.id);
        } else {
          await getBodegas(empresaSel.value.id);
        }

        if (
          empresaSel.value.name == "18 - Trab. Marítimos Oxxean SA" ||
          empresaSel.value.name == "19 - TMO Acuicola S.A" ||
          empresaSel.value.name == "25 Consorcio De Proyectos Marí"
        ) {
          await getTripulantes(empresaSel.value.id);
          await getTurnos(empresaSel.value.id);
        }

        if (lstDepartamento.value.length == 1) {
          departamentoSel.value = lstDepartamento.value[0];
        }

        // if (tipoSol.value.id == "Compra") {
        //   await getConceptos();
        // }
      }
    }
  } catch (error) {
    console.log(error);
  } finally {
    isLoading.value = false;
  }
}

async function addFiles() {
  for (var f of selectedFiles.value) {
    if (f.size > 5242880) {
      swal.fire({
        icon: "warning",
        title: "El archivo " + f.name + " no puede superar los 5 MB",
        showConfirmButton: true,
      });

      const index = selectedFiles.value.indexOf(f);
      if (index > -1) {
        selectedFiles.value.splice(index, 1);
      }
    } else {
      file.value.push(f);
    }
  }

  selectedFiles.value = [];
}

function getGUID() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0,
      v = c == "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

function filterOnlyNumber(evt: any) {
  evt = evt ? evt : window.event;
  let expect = evt.target.value.toString() + evt.key.toString();

  //solo numeros
  if (!/^[0-9]*$/.test(expect)) {
    evt.preventDefault();
  } else {
    return true;
  }
}

function filterNumber(evt: any) {
  evt = evt ? evt : window.event;
  let expect = evt.target.value.toString() + evt.key.toString();

  if (!/^[0-9]*\.?[0-9]*$/.test(expect)) {
    evt.preventDefault();
  } else {
    return true;
  }
}

function calcularTotalCantidad(item: SolicitudDetalle) {
  // if (item == null || item.cantidad == null || item.precio == null) {
  //   return;
  // }

  const precio = Number(
    String(item.precio ?? 0)
      .replace(/,/g, "")
      .replace(/\./g, ""),
  );
  const cantidad = Number(String(item.cantidad ?? 0).replace(/,/g, "."));

  if (Number.isNaN(precio) || Number.isNaN(cantidad)) {
    return;
  }

  item.precio = precio;
  item.cantidad = cantidad;
  item.total = cantidad * precio;
  compraTotal();

  // var validPrecio = currency(item.precio, {
  //   separator: ".",
  //   decimal: ",",
  //   errorOnInvalid: true,
  // });

  // var validCantidad = currency(item.cantidad, {
  //   decimal: ",",
  //   errorOnInvalid: true,
  // });

  // if (!isNaN(validPrecio.value) && !isNaN(validCantidad.value)) {
  //   item.total = validCantidad.value * validPrecio.value;

  //   compraTotal();
  // } else {
  //   swal.fire({
  //     icon: "warning",
  //     title: "Formato Incorrecto",
  //     showConfirmButton: true,
  //   });
  // }

  // item.total =
  //   parseFloat(item.cantidad.toString().replace(",", ".")) *
  //   parseFloat(item.precio.toString().replace(",", "."));
  // compraTotal();
}

function formatoCantidad(item: SolicitudDetalle) {
  const cantidad = Number(String(item.cantidad ?? 0).replace(/,/g, "."));
  if (!Number.isNaN(cantidad)) {
    item.cantidad = cantidad;
  }
}

function compraTotal() {
  total.value = lstDetalle.reduce((acc, item) => acc + (item.total ?? 0), 0);
}

function rendicionTotal(item: SolicitudDetalle) {
  const validMonto = currency(item.monto ?? 0, {
    separator: ".",
    decimal: ",",
    errorOnInvalid: true,
  });

  if (!isNaN(validMonto.value)) {
    item.monto = validMonto.value;
    total.value = lstDetalle.reduce((acc, item) => acc + (item.monto ?? 0), 0);
  } else {
    swal.fire({
      icon: "warning",
      title: "Formato Incorrecto",
      showConfirmButton: true,
    });
  }

  // this.total = this.lstDetalle.reduce(
  //   (acc, item) => acc + parseFloat(item.Monto.replace(",", ".")),
  //   0
  // );
}

function formatTotal(value: number | null): string {
  if (value == null) {
    return "";
  }
  return new Intl.NumberFormat("es-CL", {
    style: "currency",
    currency: "CLP",
  }).format(value);
}

function showDeleteDialog(item: SolicitudDetalle) {
  itemToDelete = item;
  dialogDelete.value = !dialogDelete.value;
}

function deleteMaterial(item: SolicitudDetalle) {
  //const index = lstDetalle.values.indexOf(item);
  let index = lstDetalle.findIndex((x) => x.id == item.id);
  lstDetalle.splice(index, 1);

  dialogDelete.value = !dialogDelete;

  for (let i = 0; i < lstDetalle.length; i++) {
    lstDetalle[i].id = i + 1;
  }

  detContador = lstDetalle.length + 1;
}

function validarCecoYEmpresa(
  cecoSeleccionado: string | undefined,
  regSel: Regularizacion | null
  // regSel: { value?: { id?: string } }
) {
  if (!cecoSeleccionado) {
    swal.fire({
      icon: "error",
      title: "Centro de costo no definido",
      text: "Debes seleccionar un centro de costo.",
      showConfirmButton: true,
    });
    return false;
  }

  const empiezaCon1 = cecoSeleccionado.startsWith("1");
  const empiezaCon3 = cecoSeleccionado.startsWith("3");
  const idEsNo = regSel?.id == "No" ? true : false;

  // Validación general: Ceco no permitido (no empieza ni con 1 ni con 3)
  if (!empiezaCon1 && !empiezaCon3) {
    swal.fire({
      icon: "error",
      title: "Centro de costo inválido",
      text: "Ítems de tipo consumo deben solicitarse por la empresa 19 - TMO Acuicola S.A",
      showConfirmButton: true,
    });
    return false;
  }

  // Validación por empresa
  if ((empiezaCon1 || empiezaCon3) && idEsNo) {
    swal.fire({
      icon: "warning",
      title: "Empresa inválida",
      text: "Ítems de tipo consumo deben solicitarse por la empresa 19 - TMO Acuicola S.A",
      showConfirmButton: true,
    });
    return false;
  }

  return true; // Todo está OK
}

// function parseChileDate(dateString: string): Date {
//   const [day, month, year] = dateString.split("-").map(Number);

//   // Crear fecha en zona horaria de Chile (usando UTC para evitar desfase local)
//   const chileDate = new Date(Date.UTC(year, month - 1, day));

//   // Obtener el offset de Chile en milisegundos
//   const formatter = new Intl.DateTimeFormat("es-CL", {
//     timeZone: "America/Santiago",
//     timeZoneName: "short",
//   });

//   // Obtener offset real de Chile en esa fecha
//   const parts = formatter.formatToParts(chileDate);
//   const timeZoneName =
//     parts.find((p) => p.type === "timeZoneName")?.value || "";
//   const offsetHours = /GMT([+-]\d{1,2})/.exec(timeZoneName)?.[1];

//   const offsetInMs = offsetHours ? parseInt(offsetHours) * 60 * 60 * 1000 : 0;

//   // Ajustar fecha a zona horaria de Chile
//   const localDate = new Date(chileDate.getTime() + offsetInMs);

//   return localDate;
// }

function obtenerTiposSolicitud(rut: string) {
  try {
    axios
      .get(
        store.state.url + "api/SolicitudCompra/GetTipoSolicitudes?rut=" + rut,
      )
      .then((response) => {
        if (response.status == 200) {
              let tipos = (response.data as TipoSolicitud[]) || [];

              if (idSol.value == undefined || idSol.value == null || idSol.value === "") {
                tipos = tipos.filter((t) => t.id !== "Todos");
              }

              lstTipoSolicitud.value = tipos;

              if (lstTipoSolicitud.value.length > 0) {
                if (idSol.value == undefined || idSol.value == null || idSol.value === "") {
                  tipoSol.value = lstTipoSolicitud.value[0];
                }
              }
        } else {
          const t = translateBcError(response.data.error.message); // { message, correlationId, key }
          console.log("Error al obtener los tipos de solicitud: " + t.message);
          swal.fire({
            icon: "error",
            title: "Error al obtener los tipos de solicitud",
            text: t.message,
            showConfirmButton: true,
          });
        }
      })
      .catch((error: any) => {
        const t = translateBcError(error.message); // { message, correlationId, key }
        console.log("Error al obtener los tipos de solicitud: " + t.message);

        swal.fire({
          icon: "error",
          title: "Error al obtener los tipos de solicitud",
          text: t.message,
          showConfirmButton: true,
        });
      });
  } catch (error) {
    console.log(error);
  }
}

async function getRol(email: string) {
  try {
    let tiene: Rol[] = [];

    await axios
      .get(store.state.url + "api/Rol/GetRol?email=" + email, {
        headers: {},
      })
      .then((response) => {
        if (response.status == 200) {
          tiene = response.data as Rol[];
        } else {
          console.log(response.statusText);
          tiene = [];
        }
      })
      .catch(function (error: any) {
        console.log(error.message);
        tiene = [];
      });

    return tiene;
  } catch (error) {
    console.log(error);
    return [];
  }
}

function generarMesesServicio(
  cantidadMeses: number,
  fechaInicio = new Date(),
): MesServicio[] {
  const lista: MesServicio[] = [];

  const anioInicio = fechaInicio.getFullYear();
  const mesInicio = fechaInicio.getMonth(); // 0 = enero, 11 = diciembre

  for (let i = 0; i < cantidadMeses; i++) {
    const fecha = new Date(anioInicio - 1, mesInicio + i, 1); // suma meses y deja que Date maneje el cambio de año
    const anio = fecha.getFullYear();
    const mes = (fecha.getMonth() + 1).toString().padStart(2, "0"); // "01".."12"

    const valor = `${anio}-${mes}`;
    lista.push({
      id: valor,
      nombre: valor,
    });
  }

  return lista;
}

// function validarPresupuesto(solicitud: SolicitudCompra): boolean {
//   let validado: boolean = true;

//   solicitud.detalle.forEach(async (det) => {
//     if (det.tienePresup) {
//       if (det.mesServicio == "2024-12") {
//         swal.fire({
//           icon: "warning",
//           title:
//             "El " +
//             det.material +
//             " no tiene presupuesto para el mes de diciembre del 2024",
//           showConfirmButton: true,
//         });

//         validado = false;
//         return;
//       }

//       if (det.cecoId == null) {
//         swal.fire({
//           icon: "warning",
//           title: "Debe seleccionar un ceco para el item " + det.material,
//           showConfirmButton: true,
//         });

//         validado = false;
//         return;
//       }

//       if (det.proyectoId == null) {
//         swal.fire({
//           icon: "warning",
//           title: "Debe seleccionar un proyecto para el item " + det.material,
//           showConfirmButton: true,
//         });

//         validado = false;
//         return;
//       }

//       // if (det.concepto == null) {
//       //   swal.fire({
//       //     icon: "warning",
//       //     title: "Debe seleccionar un concepto para el item " + det.material,
//       //     showConfirmButton: true,
//       //   });

//       //   validado = false;
//       //   return;
//       // }

//       let currPrep: number;

//       var depto = lstDepartamento.value.find(
//         (d) => d.id == departamentoSel.value?.id
//       );

//       var ceco = lstCeco.value.find((c) => c.id == det.cecoId);

//       var proyecto = lstProyectos.value.find((p) => p.id == det.proyectoId);

//       if (depto?.code && det.concepto && ceco?.code && proyecto?.displayName) {
//         await getPresupuesto(
//           depto.code,
//           det.concepto,
//           ceco.code,
//           proyecto?.displayName
//         ).then(async (response) => {
//           var presupuesto = response as Presupuesto;

//           if (!presupuesto) {
//             swal.fire({
//               icon: "warning",
//               title: "No se encontró presupuesto para el item " + det.material,
//               showConfirmButton: true,
//             });

//             validado = false;
//             return;
//           }

//           switch (det.mesServicio) {
//             case "2025-01":
//               currPrep = presupuesto.enero_2025 || 0;
//               break;
//             case "2025-02":
//               currPrep = presupuesto.febrero_2025 || 0;
//               break;
//             case "2025-03":
//               currPrep = presupuesto.marzo_2025 || 0;
//               break;
//             case "2025-04":
//               currPrep = presupuesto.abril_2025 || 0;
//               break;
//             case "2025-05":
//               currPrep = presupuesto.mayo_2025 || 0;
//               break;
//             case "2025-06":
//               currPrep = presupuesto.junio_2025 || 0;
//               break;
//             case "2025-07":
//               currPrep = presupuesto.julio_2025 || 0;
//               break;
//             case "2025-08":
//               currPrep = presupuesto.agosto_2025 || 0;
//               break;
//             case "2025-09":
//               currPrep = presupuesto.septiembre_2025 || 0;
//               break;
//             case "2025-10":
//               currPrep = presupuesto.octubre_2025 || 0;
//               break;
//             case "2025-11":
//               currPrep = presupuesto.noviembre_2025 || 0;
//               break;
//             case "2025-12":
//               currPrep = presupuesto.diciembre_2025 || 0;
//               break;
//             default:
//               currPrep = 0;
//               break;
//           }

//           if (currPrep >= 0) {
//             swal.fire({
//               icon: "warning",
//               title:
//                 "El item " +
//                 det.material +
//                 " excede el presupuesto disponible del material " +
//                 det.material,
//               showConfirmButton: true,
//             });

//             validado = false;
//             return;
//           }

//           if ((det.total ?? 0) > currPrep * -1) {
//             swal.fire({
//               icon: "warning",
//               title:
//                 "El item " +
//                 det.material +
//                 " excede el presupuesto disponible del material " +
//                 det.material,
//               showConfirmButton: true,
//             });

//             validado = false;
//             return;
//           }
//         });
//       }

//       if (!validado) {
//         return false;
//       }

//       enviarSolicitud(solicitud);
//       return true;
//     }
//   });

//   return false;
// }
</script>
